import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Scalar for BigDecimal */
  BigDecimal: { input: any; output: any; }
  /** Scalar for BigInteger */
  BigInteger: { input: any; output: any; }
  /** Scalar for DateTime */
  DateTime: { input: any; output: any; }
  /** Scalar for Void */
  Void: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsConfiguration = {
  __typename?: 'AnalyticsConfiguration';
  dataTypes: Array<Maybe<AnalyticsDataType>>;
  resultTypes: Array<Maybe<AnalyticsResultType>>;
};

export type AnalyticsConfigurationInput = {
  dataTypes: Array<InputMaybe<AnalyticsDataTypeInput>>;
  resultTypes: Array<InputMaybe<AnalyticsResultTypeInput>>;
};

export type AnalyticsDataType = {
  __typename?: 'AnalyticsDataType';
  name: Scalars['String']['output'];
};

export type AnalyticsDataTypeInput = {
  name: Scalars['String']['input'];
};

export type AnalyticsResult = {
  __typename?: 'AnalyticsResult';
  analyticsDataType: Type;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  device: MdmDevice;
  deviceType?: Maybe<Scalars['String']['output']>;
  id: AnalyticsResultId;
  mdmObject: MdmObject;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<SeverityType>;
};

export type AnalyticsResultDto = {
  __typename?: 'AnalyticsResultDTO';
  analyticsDataType: Type;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<AnalyticsResultId>;
  mdmDevice?: Maybe<MdmDeviceDto>;
  mdmObject?: Maybe<MdmObjectDto>;
  mdmProject?: Maybe<MdmProjectDto>;
  severity?: Maybe<SeverityType>;
};

export type AnalyticsResultId = {
  __typename?: 'AnalyticsResultId';
  analyticsType: Scalars['String']['output'];
  /** ISO-8601 */
  date: Scalars['DateTime']['output'];
  mdmObjectId?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsResultIdInput = {
  analyticsType: Scalars['String']['input'];
  /** ISO-8601 */
  date: Scalars['DateTime']['input'];
  mdmObjectId?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsResultInputInput = {
  analyticsDataType: Type;
  analyticsType: Scalars['String']['input'];
  /** ISO-8601 */
  date: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  deviceId?: InputMaybe<Scalars['String']['input']>;
  mdmObjectId: Scalars['String']['input'];
  severity: SeverityType;
};

export type AnalyticsResultType = {
  __typename?: 'AnalyticsResultType';
  description?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AnalyticsResultTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type AndFilter = {
  __typename?: 'AndFilter';
  cond: FilterOp;
  property: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AndFilterInput = {
  cond: FilterOp;
  property: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AnyFilterExpressionInput = {
  cond?: InputMaybe<FilterOp>;
  ignoreCase?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<AnyFilterExpressionInput>;
  op?: InputMaybe<BooleanOp>;
  property?: InputMaybe<Scalars['String']['input']>;
  right?: InputMaybe<AnyFilterExpressionInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Attribute = {
  __typename?: 'Attribute';
  enums?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
  parent?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reading?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: AttributeType;
};

export type AttributeData_String = {
  __typename?: 'AttributeData_String';
  type: AttributeType;
  value?: Maybe<Scalars['String']['output']>;
};

export type AttributeData_StringInput = {
  type: AttributeType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeInput = {
  enums?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['String']['input'];
  parent?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reading?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: AttributeType;
};

export enum AttributeType {
  Boolean = 'BOOLEAN',
  Enum = 'ENUM',
  Image = 'IMAGE',
  Link = 'LINK',
  Number = 'NUMBER',
  String = 'STRING'
}

export enum BooleanOp {
  And = 'AND',
  Or = 'OR'
}

export type BoundDatasets = {
  __typename?: 'BoundDatasets';
  all: Array<Maybe<DatasetInfo>>;
  mapped: Array<Maybe<BoundDatasetsDeviceMapping>>;
};

export type BoundDatasetsDeviceMapping = {
  __typename?: 'BoundDatasetsDeviceMapping';
  dataset?: Maybe<DatasetInfo>;
  mapping: Scalars['String']['output'];
};

export type BoundDatasetsObject = {
  __typename?: 'BoundDatasetsObject';
  all: Array<Maybe<BoundDatasetsObjectMapping>>;
  direct: Array<Maybe<BoundDatasetsObjectMapping>>;
  indirect: Array<Maybe<BoundDatasetsObjectMapping>>;
  mapped: Array<Maybe<BoundDatasetsObjectMapping>>;
};

export type BoundDatasetsObjectMapping = {
  __typename?: 'BoundDatasetsObjectMapping';
  dataset?: Maybe<DatasetInfo>;
  datasetMapping?: Maybe<Scalars['String']['output']>;
  roleIdentifier?: Maybe<Scalars['String']['output']>;
  roleInObject?: Maybe<Scalars['String']['output']>;
  source: BoundDatasetsObjectMappingSource;
};

export enum BoundDatasetsObjectMappingSource {
  Device = 'DEVICE',
  Direct = 'DIRECT'
}

export type ByIdAndDateRangeReqInput = {
  andFilters?: InputMaybe<Array<InputMaybe<AnyFilterExpressionInput>>>;
  filter?: InputMaybe<AnyFilterExpressionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<InstantRangeDtoInput>;
  skip: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
  take: Scalars['Int']['input'];
};

export type ByProjectIdReqInput = {
  andFilters?: InputMaybe<Array<InputMaybe<AnyFilterExpressionInput>>>;
  filter?: InputMaybe<AnyFilterExpressionInput>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
  take: Scalars['Int']['input'];
};

export type ColumnOrder = {
  __typename?: 'ColumnOrder';
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type ColumnOrderInput = {
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CompanyObject = {
  companyReference: Scalars['String']['output'];
};

export enum DataAccessType {
  Continuous = 'CONTINUOUS',
  DataModelDay = 'DATA_MODEL_DAY',
  Normal = 'NORMAL'
}

export enum DatasetBindingType {
  MdmDeviceId = 'MDM_DEVICE_ID',
  MdmDeviceIdentifier = 'MDM_DEVICE_IDENTIFIER',
  MdmObjectId = 'MDM_OBJECT_ID',
  MdmObjectIdentifier = 'MDM_OBJECT_IDENTIFIER',
  None = 'NONE'
}

export enum DatasetClass {
  AdvancedDataset = 'ADVANCED_DATASET',
  CategorizedDataset = 'CATEGORIZED_DATASET',
  CategorizedStringDataset = 'CATEGORIZED_STRING_DATASET',
  ElectricityDataset = 'ELECTRICITY_DATASET',
  ProcessedDataset = 'PROCESSED_DATASET',
  ProcessedIntegralDataset = 'PROCESSED_INTEGRAL_DATASET',
  ProcessedPriorityFirstDataset = 'PROCESSED_PRIORITY_FIRST_DATASET',
  ProcessedPythonDataset = 'PROCESSED_PYTHON_DATASET',
  RemoteCategorizedDataset = 'REMOTE_CATEGORIZED_DATASET',
  RemoteDataset = 'REMOTE_DATASET',
  RemoteStringDataset = 'REMOTE_STRING_DATASET',
  SimpleDataset = 'SIMPLE_DATASET'
}

export type DatasetInfo = {
  __typename?: 'DatasetInfo';
  accessType?: Maybe<DataAccessType>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  boundToId?: Maybe<Scalars['String']['output']>;
  boundToType?: Maybe<DatasetBindingType>;
  categoryId?: Maybe<Scalars['BigInteger']['output']>;
  categoryTitle?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['BigInteger']['output']>;
  dataType?: Maybe<DatasetType>;
  datasetClass?: Maybe<DatasetClass>;
  decimalPlaces?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deviceId?: Maybe<Scalars['BigInteger']['output']>;
  groupId?: Maybe<Scalars['BigInteger']['output']>;
  groupTitle?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  proxied?: Maybe<Scalars['Boolean']['output']>;
  stringValueMapper?: Maybe<Scalars['BigInteger']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export enum DatasetMode {
  Direct = 'DIRECT',
  Duplicated = 'DUPLICATED'
}

export enum DatasetType {
  Arbitrary = 'ARBITRARY',
  ArbitraryMinutes = 'ARBITRARY_MINUTES',
  ArbitrarySeconds = 'ARBITRARY_SECONDS',
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Minutes = 'MINUTES',
  Monthly = 'MONTHLY',
  Seconds = 'SECONDS',
  Weekly = 'WEEKLY'
}

export type DeviceLastMeasurement = {
  __typename?: 'DeviceLastMeasurement';
  datasetIdentifier: Scalars['String']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  mapping?: Maybe<Scalars['String']['output']>;
  tags: Array<Maybe<Scalars['String']['output']>>;
  /** ISO-8601 */
  time: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type DeviceLastMeasurementDatasetInput = {
  datasetIdentifier?: InputMaybe<Scalars['String']['input']>;
  datasetTags: Array<InputMaybe<Scalars['String']['input']>>;
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  time?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type DeviceLastMeasurementInput = {
  datasets?: InputMaybe<Array<InputMaybe<DeviceLastMeasurementDatasetInput>>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceMeasurement = {
  __typename?: 'DeviceMeasurement';
  mapping?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  time: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type DeviceObjectRelation = {
  __typename?: 'DeviceObjectRelation';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  mdmDevice: MdmDevice;
  mdmObject: MdmObject;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  roleIdentifier?: Maybe<Scalars['String']['output']>;
  roleInObject?: Maybe<Scalars['String']['output']>;
};

export type DeviceObjectRelationInput = {
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  mdmDevice: MdmDeviceInput;
  mdmObject: MdmObjectInput;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  roleIdentifier?: InputMaybe<Scalars['String']['input']>;
  roleInObject?: InputMaybe<Scalars['String']['input']>;
};

export enum DeviceStatus {
  NoData = 'NO_DATA',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type DevicesConfiguration = {
  __typename?: 'DevicesConfiguration';
  customFields: Array<Maybe<Attribute>>;
  measurementTypes?: Maybe<Array<Maybe<MeasurementTypeDef>>>;
};

export type DevicesConfigurationInput = {
  customFields: Array<InputMaybe<AttributeInput>>;
  measurementTypes?: InputMaybe<Array<InputMaybe<MeasurementTypeDefInput>>>;
};

export type Entry_String_AttributeData_String = {
  __typename?: 'Entry_String_AttributeData_String';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<AttributeData_String>;
};

export type Entry_String_AttributeData_StringInputInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<AttributeData_StringInput>;
};

export type Entry_String_String = {
  __typename?: 'Entry_String_String';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Entry_String_StringInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EnumItem = {
  __typename?: 'EnumItem';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Field = {
  __typename?: 'Field';
  containerType: Scalars['String']['output'];
  enum?: Maybe<Array<Maybe<EnumItem>>>;
  fieldType?: Maybe<Scalars['String']['output']>;
  inputType?: Maybe<FilterValueType>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  leaf: Scalars['Boolean']['output'];
  propertyType: PropertyType;
};

export type FilterInfo = {
  __typename?: 'FilterInfo';
  allFields: Array<Maybe<Field>>;
  allOperators: Array<Maybe<Op>>;
};

export enum FilterOp {
  Contains = 'CONTAINS',
  Eq = 'EQ',
  Excludes = 'EXCLUDES',
  Gt = 'GT',
  Gte = 'GTE',
  IsBlank = 'IS_BLANK',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ',
  NotBlank = 'NOT_BLANK'
}

export enum FilterValueType {
  Boolean = 'BOOLEAN',
  Decimal = 'DECIMAL',
  Default = 'DEFAULT',
  Enum = 'ENUM',
  Integer = 'INTEGER',
  String = 'STRING',
  UserId = 'USER_ID',
  UtcDate = 'UTC_DATE'
}

export type HeatData = {
  __typename?: 'HeatData';
  /** ISO-8601 */
  date?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['BigInteger']['output']>;
};

export type InstantRangeDtoInput = {
  /** ISO-8601 */
  end: Scalars['DateTime']['input'];
  endInclusive: Scalars['Boolean']['input'];
  /** ISO-8601 */
  start: Scalars['DateTime']['input'];
  startInclusive: Scalars['Boolean']['input'];
};

export type KeycloakUser = {
  __typename?: 'KeycloakUser';
  displayName: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type LocationInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type MdmDevice = {
  __typename?: 'MdmDevice';
  config?: Maybe<MdmDeviceConfiguration>;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<Entry_String_AttributeData_String>>>;
  history?: Maybe<Array<Maybe<MdmDeviceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  objectRelation?: Maybe<DeviceObjectRelation>;
  project?: Maybe<MdmProject>;
  tags: Array<Maybe<Scalars['String']['output']>>;
};


export type MdmDeviceCustomFieldsArgs = {
  key?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MdmDeviceConfigDto = {
  __typename?: 'MdmDeviceConfigDTO';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  measurementMappings: Array<Maybe<MeasurementMappingInput>>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  vitalityThreshold?: Maybe<Scalars['Int']['output']>;
};

export type MdmDeviceConfigDtoInput = {
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  measurementMappings: Array<InputMaybe<MeasurementMappingInputInput>>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vitalityThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type MdmDeviceConfiguration = {
  __typename?: 'MdmDeviceConfiguration';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  measurementMappings: Array<Maybe<Entry_String_String>>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  project?: Maybe<MdmProject>;
  title?: Maybe<Scalars['String']['output']>;
  vitalityThreshold?: Maybe<Scalars['Int']['output']>;
};


export type MdmDeviceConfigurationMeasurementMappingsArgs = {
  key?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MdmDeviceConfigurationInput = {
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  measurementMappings: Array<InputMaybe<Entry_String_StringInput>>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<MdmProjectInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  vitalityThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type MdmDeviceDto = {
  __typename?: 'MdmDeviceDTO';
  boundDatasets: BoundDatasets;
  config?: Maybe<MdmDeviceConfigDto>;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customFields?: Maybe<Array<Maybe<Entry_String_AttributeData_String>>>;
  datasetCount: Scalars['Int']['output'];
  history?: Maybe<Array<Maybe<MdmDeviceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  lastMeasurements: Array<Maybe<DeviceMeasurement>>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  objectRelation?: Maybe<MdmObjectDeviceRelationDto>;
  project?: Maybe<MdmProject>;
  roleIdentifier?: Maybe<Scalars['String']['output']>;
  roleInObject?: Maybe<Scalars['String']['output']>;
  status: MdmDeviceStatusDto;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type MdmDeviceDtoCustomFieldsArgs = {
  key?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MdmDeviceDtoInput = {
  config?: InputMaybe<MdmDeviceConfigDtoInput>;
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<Entry_String_AttributeData_StringInputInput>>>;
  history?: InputMaybe<Array<InputMaybe<MdmDeviceHistoryInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  project?: InputMaybe<MdmProjectInput>;
  roleIdentifier?: InputMaybe<Scalars['String']['input']>;
  roleInObject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MdmDeviceHistory = {
  __typename?: 'MdmDeviceHistory';
  address: Scalars['String']['output'];
  objectId?: Maybe<Scalars['String']['output']>;
  objectIdentifier: Scalars['String']['output'];
  /** ISO-8601 */
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type MdmDeviceHistoryInput = {
  address: Scalars['String']['input'];
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectIdentifier: Scalars['String']['input'];
  /** ISO-8601 */
  timestamp: Scalars['DateTime']['input'];
  value: Scalars['Float']['input'];
};

export type MdmDeviceInput = {
  config?: InputMaybe<MdmDeviceConfigurationInput>;
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<Entry_String_AttributeData_StringInputInput>>>;
  history?: InputMaybe<Array<InputMaybe<MdmDeviceHistoryInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  objectRelation?: InputMaybe<DeviceObjectRelationInput>;
  project?: InputMaybe<MdmProjectInput>;
  tags: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MdmDeviceStatus = {
  __typename?: 'MdmDeviceStatus';
  deviceIdentifier?: Maybe<Scalars['String']['output']>;
  id: MdmDeviceStatusId;
  /** ISO-8601 */
  lastMeasurementDate?: Maybe<Scalars['DateTime']['output']>;
  status: DeviceStatus;
};

export type MdmDeviceStatusDto = {
  __typename?: 'MdmDeviceStatusDTO';
  deviceId: Scalars['String']['output'];
  /** ISO-8601 */
  lastMeasurementDate?: Maybe<Scalars['DateTime']['output']>;
  status: DeviceStatus;
  /** ISO-8601 */
  timestamp: Scalars['DateTime']['output'];
};

export type MdmDeviceStatusId = {
  __typename?: 'MdmDeviceStatusId';
  deviceId?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  timestamp: Scalars['DateTime']['output'];
};

export type MdmObject = {
  __typename?: 'MdmObject';
  address?: Maybe<Address>;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customFields: Array<Maybe<Entry_String_AttributeData_String>>;
  description?: Maybe<Scalars['String']['output']>;
  deviceRelations: Array<Maybe<DeviceObjectRelation>>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  jobs: Array<Maybe<MdmObjectJob>>;
  location?: Maybe<Location>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  notes: Array<Maybe<MdmObjectNote>>;
  project: MdmProject;
  tags: Array<Maybe<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type MdmObjectCustomFieldsArgs = {
  key?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MdmObjectDto = {
  __typename?: 'MdmObjectDTO';
  address?: Maybe<Address>;
  boundDatasets: BoundDatasetsObject;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<Maybe<Entry_String_AttributeData_String>>>;
  description?: Maybe<Scalars['String']['output']>;
  deviceRelations: Array<MdmObjectDeviceRelationDto>;
  id?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  info: MdmObjectInfo;
  location?: Maybe<Location>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type MdmObjectDtoCustomFieldsArgs = {
  key?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MdmObjectDtoInput = {
  address?: InputMaybe<AddressInput>;
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<InputMaybe<Entry_String_AttributeData_StringInputInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MdmObjectDeviceRelationDto = {
  __typename?: 'MdmObjectDeviceRelationDTO';
  mdmDevice?: Maybe<MdmDeviceDto>;
  mdmObject?: Maybe<MdmObjectDto>;
  roleIdentifier?: Maybe<Scalars['String']['output']>;
  roleInObject?: Maybe<Scalars['String']['output']>;
};

export type MdmObjectDeviceRelationDtoInput = {
  mdmDevice?: InputMaybe<MdmDeviceDtoInput>;
  mdmObject?: InputMaybe<MdmObjectDtoInput>;
  roleIdentifier?: InputMaybe<Scalars['String']['input']>;
  roleInObject?: InputMaybe<Scalars['String']['input']>;
};

export type MdmObjectInfo = {
  __typename?: 'MdmObjectInfo';
  jobsCount: Scalars['Int']['output'];
  notesCount: Scalars['Int']['output'];
};

export type MdmObjectInput = {
  address?: InputMaybe<AddressInput>;
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customFields: Array<InputMaybe<Entry_String_AttributeData_StringInputInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceRelations: Array<InputMaybe<DeviceObjectRelationInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  jobs: Array<InputMaybe<MdmObjectJobInput>>;
  location?: InputMaybe<LocationInput>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  notes: Array<InputMaybe<MdmObjectNoteInput>>;
  project: MdmProjectInput;
  tags: Array<InputMaybe<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MdmObjectJob = {
  __typename?: 'MdmObjectJob';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['BigInteger']['output']>;
  mdmObject?: Maybe<MdmObject>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<SeverityType>;
  /** ISO-8601 */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<StatusType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MdmObjectJobDto = {
  __typename?: 'MdmObjectJobDTO';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUsername: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['BigInteger']['output']>;
  mdmObject?: Maybe<MdmObject>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<SeverityType>;
  /** ISO-8601 */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<StatusType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MdmObjectJobDtoInput = {
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['BigInteger']['input']>;
  mdmObject?: InputMaybe<MdmObjectInput>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<SeverityType>;
  /** ISO-8601 */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<StatusType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MdmObjectJobInput = {
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['BigInteger']['input']>;
  mdmObject?: InputMaybe<MdmObjectInput>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<SeverityType>;
  /** ISO-8601 */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<StatusType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MdmObjectNote = {
  __typename?: 'MdmObjectNote';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['BigInteger']['output']>;
  mdmObject?: Maybe<MdmObject>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type MdmObjectNoteDto = {
  __typename?: 'MdmObjectNoteDTO';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUsername: Scalars['String']['output'];
  id?: Maybe<Scalars['BigInteger']['output']>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  modifiedByUsername: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type MdmObjectNoteDtoInput = {
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInteger']['input']>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MdmObjectNoteInput = {
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['BigInteger']['input']>;
  mdmObject?: InputMaybe<MdmObjectInput>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type MdmProject = CompanyObject & {
  __typename?: 'MdmProject';
  companyReference: Scalars['String']['output'];
  configuration: MdmProjectConfiguration;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetMode: DatasetMode;
  deviceConfigs: Array<Maybe<MdmDeviceConfiguration>>;
  devices: Array<Maybe<MdmDevice>>;
  id?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  objects: Array<Maybe<MdmObject>>;
  title: Scalars['String']['output'];
};

export type MdmProjectConfiguration = {
  __typename?: 'MdmProjectConfiguration';
  analyticsConfiguration: AnalyticsConfiguration;
  deviceConfiguration: DevicesConfiguration;
  objectConfiguration: ObjectsConfiguration;
};

export type MdmProjectConfigurationInput = {
  analyticsConfiguration: AnalyticsConfigurationInput;
  deviceConfiguration: DevicesConfigurationInput;
  objectConfiguration: ObjectsConfigurationInput;
};

export type MdmProjectDto = {
  __typename?: 'MdmProjectDTO';
  companyReference?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<MdmProjectConfiguration>;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetMode?: Maybe<DatasetMode>;
  deviceConfigs?: Maybe<Array<Maybe<MdmDeviceConfigDto>>>;
  devices?: Maybe<Array<Maybe<MdmDeviceDto>>>;
  filterInfo: FilterInfo;
  id?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  objects?: Maybe<Array<Maybe<MdmObjectDto>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MdmProjectDtoInput = {
  companyReference?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<MdmProjectConfigurationInput>;
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  datasetMode?: InputMaybe<DatasetMode>;
  deviceConfigs?: InputMaybe<Array<InputMaybe<MdmDeviceConfigDtoInput>>>;
  devices?: InputMaybe<Array<InputMaybe<MdmDeviceDtoInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  objects?: InputMaybe<Array<InputMaybe<MdmObjectDtoInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MdmProjectInput = {
  companyReference: Scalars['String']['input'];
  configuration: MdmProjectConfigurationInput;
  /** ISO-8601 */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  datasetMode: DatasetMode;
  deviceConfigs: Array<InputMaybe<MdmDeviceConfigurationInput>>;
  devices: Array<InputMaybe<MdmDeviceInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  objects: Array<InputMaybe<MdmObjectInput>>;
  title: Scalars['String']['input'];
};

export type MdmProjectInputInput = {
  companyReference?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<MdmProjectConfigurationInput>;
  datasetMode?: InputMaybe<DatasetMode>;
  deviceConfigs?: InputMaybe<Array<InputMaybe<MdmDeviceConfigDtoInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MeasurementMappingInput = {
  __typename?: 'MeasurementMappingInput';
  key: Scalars['String']['output'];
  value: Array<Maybe<Scalars['String']['output']>>;
};

export type MeasurementMappingInputInput = {
  key: Scalars['String']['input'];
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MeasurementTypeDef = {
  __typename?: 'MeasurementTypeDef';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MeasurementTypeDefInput = {
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  /** Clear history of all devices */
  clearDevicesHistory?: Maybe<Scalars['Void']['output']>;
  /** Create job */
  createJob: MdmObjectJobDto;
  /** Create new device */
  createMdmDevice: MdmDeviceDto;
  /** Create new object */
  createMdmObject: MdmObjectDto;
  /** Create new mdm project */
  createMdmProject: MdmProjectDto;
  createNote: MdmObjectNoteDto;
  /** Create or update new analytics result */
  createOrUpdateAnalyticsResult: AnalyticsResultDto;
  /** Create device configuration */
  createUpdateDeviceConfig: MdmDeviceConfigDto;
  /** Delete analytics result */
  deleteAnalyticsResult: AnalyticsResultDto;
  /** delete device configuration */
  deleteDeviceConfig: MdmDeviceConfigDto;
  /** Delete job */
  deleteJob: MdmObjectJobDto;
  /** Delete mdm device */
  deleteMdmDevice: MdmDeviceDto;
  /** Delete object */
  deleteMdmObject: MdmObjectDto;
  /** Delete project */
  deleteMdmProject: MdmProjectDto;
  deleteNote: MdmObjectNoteDto;
  /** Delete saved table filter */
  deleteTableFilter: UserSettingsDto;
  /** Update device history */
  updateDeviceHistory: Array<MdmDeviceHistory>;
  /** Update job */
  updateJob: MdmObjectJobDto;
  updateLastMeasurements?: Maybe<Scalars['Void']['output']>;
  /** Update device */
  updateMdmDevice: MdmDeviceDto;
  /** Update object */
  updateMdmObject: MdmObjectDto;
  /** Update mdm project */
  updateMdmProject: MdmProjectDto;
  updateNote: MdmObjectNoteDto;
  /** Create or modify object device relation */
  updateObjectDeviceRelation?: Maybe<MdmObjectDeviceRelationDto>;
  /** Update rows per page for user */
  updateTableDetailsForUser: UserSettingsDto;
  /** Update table filters for user */
  updateTableFilters: UserSettingsDto;
};


/** Mutation root */
export type MutationCreateJobArgs = {
  mdmObjectJob: MdmObjectJobDtoInput;
  objectId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationCreateMdmDeviceArgs = {
  input: MdmDeviceDtoInput;
  objectId?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationCreateMdmObjectArgs = {
  input: MdmObjectDtoInput;
};


/** Mutation root */
export type MutationCreateMdmProjectArgs = {
  input: MdmProjectInputInput;
};


/** Mutation root */
export type MutationCreateNoteArgs = {
  mdmObjectId: Scalars['String']['input'];
  note: Scalars['String']['input'];
};


/** Mutation root */
export type MutationCreateOrUpdateAnalyticsResultArgs = {
  allowUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  input: AnalyticsResultInputInput;
};


/** Mutation root */
export type MutationCreateUpdateDeviceConfigArgs = {
  input: MdmDeviceConfigDtoInput;
};


/** Mutation root */
export type MutationDeleteAnalyticsResultArgs = {
  id: AnalyticsResultIdInput;
};


/** Mutation root */
export type MutationDeleteDeviceConfigArgs = {
  configId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteJobArgs = {
  id: Scalars['BigInteger']['input'];
};


/** Mutation root */
export type MutationDeleteMdmDeviceArgs = {
  id: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteMdmObjectArgs = {
  id: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteMdmProjectArgs = {
  id: Scalars['String']['input'];
};


/** Mutation root */
export type MutationDeleteNoteArgs = {
  id: Scalars['BigInteger']['input'];
};


/** Mutation root */
export type MutationDeleteTableFilterArgs = {
  filterId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdateDeviceHistoryArgs = {
  deviceId: Scalars['String']['input'];
  input: MdmDeviceHistoryInput;
};


/** Mutation root */
export type MutationUpdateJobArgs = {
  mdmObjectJob: MdmObjectJobDtoInput;
};


/** Mutation root */
export type MutationUpdateLastMeasurementsArgs = {
  req: DeviceLastMeasurementInput;
};


/** Mutation root */
export type MutationUpdateMdmDeviceArgs = {
  input: MdmDeviceDtoInput;
  objectId?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationUpdateMdmObjectArgs = {
  input: MdmObjectDtoInput;
};


/** Mutation root */
export type MutationUpdateMdmProjectArgs = {
  input: MdmProjectDtoInput;
};


/** Mutation root */
export type MutationUpdateNoteArgs = {
  note: MdmObjectNoteDtoInput;
};


/** Mutation root */
export type MutationUpdateObjectDeviceRelationArgs = {
  input: MdmObjectDeviceRelationDtoInput;
};


/** Mutation root */
export type MutationUpdateTableDetailsForUserArgs = {
  projectId: Scalars['String']['input'];
  tableDetails: TablesDetailsInput;
};


/** Mutation root */
export type MutationUpdateTableFiltersArgs = {
  projectId: Scalars['String']['input'];
  tableFilter: TableFilterInput;
};

export type ObjectDefinition = {
  __typename?: 'ObjectDefinition';
  id: Scalars['String']['output'];
  measurementTypes: Array<Maybe<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
};

export type ObjectDefinitionInput = {
  id: Scalars['String']['input'];
  measurementTypes: Array<InputMaybe<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type ObjectsConfiguration = {
  __typename?: 'ObjectsConfiguration';
  customFields: Array<Maybe<Attribute>>;
  definitions?: Maybe<Array<Maybe<ObjectDefinition>>>;
};

export type ObjectsConfigurationInput = {
  customFields: Array<InputMaybe<AttributeInput>>;
  definitions?: InputMaybe<Array<InputMaybe<ObjectDefinitionInput>>>;
};

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type OffsetPage_AnalyticsResultDto = {
  __typename?: 'OffsetPage_AnalyticsResultDTO';
  items: Array<Maybe<AnalyticsResultDto>>;
  pageInfo?: Maybe<OffsetPageInfo>;
};

export type OffsetPage_MdmDeviceDto = {
  __typename?: 'OffsetPage_MdmDeviceDTO';
  items: Array<Maybe<MdmDeviceDto>>;
  pageInfo?: Maybe<OffsetPageInfo>;
};

export type OffsetPage_MdmObjectDto = {
  __typename?: 'OffsetPage_MdmObjectDTO';
  items: Array<Maybe<MdmObjectDto>>;
  pageInfo?: Maybe<OffsetPageInfo>;
};

export type Op = {
  __typename?: 'Op';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type OpenStreetAddress = {
  __typename?: 'OpenStreetAddress';
  displayName?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type PanacheEntity = {
  __typename?: 'PanacheEntity';
  id?: Maybe<Scalars['BigInteger']['output']>;
};

export enum PropertyType {
  ComputedField = 'COMPUTED_FIELD',
  CustomField = 'CUSTOM_FIELD',
  Simple = 'SIMPLE'
}

/** Query root */
export type Query = {
  __typename?: 'Query';
  /** Get analytics results by object id and date range based by filter */
  allAnalyticsResultsByObjectIdAndDateRangePaged: OffsetPage_AnalyticsResultDto;
  /** Get analytics results by project id and date range based by filter */
  allAnalyticsResultsByProjectIdAndDateRangePaged: OffsetPage_AnalyticsResultDto;
  /** Get all jobs by object id */
  allJobsByObjectId: Array<MdmObjectJobDto>;
  /** Get all jobs by project id */
  allJobsByProjectId: Array<MdmObjectJobDto>;
  allLastMeasurements: Array<DeviceLastMeasurement>;
  /** Get all devices */
  allMdmDevices: Array<MdmDeviceDto>;
  allNotesByObjectId: Array<MdmObjectNoteDto>;
  /** Get analytic's heatmap by object id and date range */
  analyticsHeatmapByObjectIdAndDateRange: Array<HeatData>;
  /** Get analytic's heatmap by project id and date range */
  analyticsHeatmapByProjectIdAndDateRange: Array<HeatData>;
  /** Get coordinates from address */
  coordinates: Array<Maybe<OpenStreetAddress>>;
  /** Get filer info */
  filterInfoForProject: FilterInfo;
  /** Get job by id */
  jobById: MdmObjectJobDto;
  /** Get device by id */
  mdmDeviceById?: Maybe<MdmDeviceDto>;
  /** Get device by identifier */
  mdmDeviceByIdentifier?: Maybe<MdmDeviceDto>;
  /** Get device status records */
  mdmDeviceStatusRecords: Array<MdmDeviceStatusDto>;
  /** Get devices by project id */
  mdmDevicesByProjectId: Array<MdmDeviceDto>;
  /** Get project devices based by filter */
  mdmDevicesByProjectIdPaged: OffsetPage_MdmDeviceDto;
  /** Get object by id */
  mdmObjectById: MdmObjectDto;
  /** Get all objects by project id */
  mdmObjectsByProjectId: Array<MdmObjectDto>;
  /** Get project objects based by filter */
  mdmObjectsByProjectIdPaged: OffsetPage_MdmObjectDto;
  /** Get mdm project by id */
  mdmProjectById: MdmProjectDto;
  /** Get all mdm projects by company reference */
  mdmProjectsByCompany: Array<Maybe<MdmProjectDto>>;
  noteById: MdmObjectNoteDto;
  userById?: Maybe<KeycloakUser>;
  /** Get user settings */
  userSettings: UserSettingsDto;
};


/** Query root */
export type QueryAllAnalyticsResultsByObjectIdAndDateRangePagedArgs = {
  req: ByIdAndDateRangeReqInput;
};


/** Query root */
export type QueryAllAnalyticsResultsByProjectIdAndDateRangePagedArgs = {
  req: ByIdAndDateRangeReqInput;
};


/** Query root */
export type QueryAllJobsByObjectIdArgs = {
  id: Scalars['String']['input'];
};


/** Query root */
export type QueryAllJobsByProjectIdArgs = {
  id: Scalars['String']['input'];
};


/** Query root */
export type QueryAllNotesByObjectIdArgs = {
  id: Scalars['String']['input'];
};


/** Query root */
export type QueryAnalyticsHeatmapByObjectIdAndDateRangeArgs = {
  id: Scalars['String']['input'];
  range: InstantRangeDtoInput;
};


/** Query root */
export type QueryAnalyticsHeatmapByProjectIdAndDateRangeArgs = {
  id: Scalars['String']['input'];
  range: InstantRangeDtoInput;
};


/** Query root */
export type QueryCoordinatesArgs = {
  address: AddressInput;
};


/** Query root */
export type QueryFilterInfoForProjectArgs = {
  projectId: Scalars['String']['input'];
};


/** Query root */
export type QueryJobByIdArgs = {
  id: Scalars['BigInteger']['input'];
};


/** Query root */
export type QueryMdmDeviceByIdArgs = {
  id: Scalars['String']['input'];
};


/** Query root */
export type QueryMdmDeviceByIdentifierArgs = {
  identifier: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


/** Query root */
export type QueryMdmDeviceStatusRecordsArgs = {
  deviceId: Scalars['String']['input'];
};


/** Query root */
export type QueryMdmDevicesByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


/** Query root */
export type QueryMdmDevicesByProjectIdPagedArgs = {
  req: ByProjectIdReqInput;
};


/** Query root */
export type QueryMdmObjectByIdArgs = {
  id: Scalars['String']['input'];
};


/** Query root */
export type QueryMdmObjectsByProjectIdArgs = {
  projectId: Scalars['String']['input'];
};


/** Query root */
export type QueryMdmObjectsByProjectIdPagedArgs = {
  req: ByProjectIdReqInput;
};


/** Query root */
export type QueryMdmProjectByIdArgs = {
  id: Scalars['String']['input'];
};


/** Query root */
export type QueryMdmProjectsByCompanyArgs = {
  companyReference: Scalars['String']['input'];
};


/** Query root */
export type QueryNoteByIdArgs = {
  id: Scalars['BigInteger']['input'];
};


/** Query root */
export type QueryUserByIdArgs = {
  id: Scalars['String']['input'];
};


/** Query root */
export type QueryUserSettingsArgs = {
  id: Scalars['String']['input'];
};

export enum SeverityType {
  High = 'HIGH',
  Highest = 'HIGHEST',
  Low = 'LOW',
  Lowest = 'LOWEST',
  Medium = 'MEDIUM'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortInput = {
  direction: SortDirection;
  property: Scalars['String']['input'];
};

export enum StatusType {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO'
}

export type TableFilter = {
  __typename?: 'TableFilter';
  andFilters: Array<Maybe<AndFilter>>;
  id?: Maybe<Scalars['String']['output']>;
  tableName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TableFilterInput = {
  andFilters: Array<InputMaybe<AndFilterInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  tableName: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type TablesDetails = {
  __typename?: 'TablesDetails';
  columnOrders: Array<Maybe<ColumnOrder>>;
  rows: Scalars['Int']['output'];
  table: Scalars['String']['output'];
};

export type TablesDetailsInput = {
  columnOrders: Array<InputMaybe<ColumnOrderInput>>;
  rows: Scalars['Int']['input'];
  table: Scalars['String']['input'];
};

export enum Type {
  NoData = 'NO_DATA'
}

export type UserSettings = {
  __typename?: 'UserSettings';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: UserSettingsId;
  /** ISO-8601 */
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  tableFilters?: Maybe<Array<Maybe<TableFilter>>>;
  tablesDetails: Array<Maybe<TablesDetails>>;
};

export type UserSettingsDto = {
  __typename?: 'UserSettingsDto';
  id?: Maybe<UserSettingsId>;
  tableFilters?: Maybe<Array<Maybe<TableFilter>>>;
  tablesDetails?: Maybe<Array<Maybe<TablesDetails>>>;
};

export type UserSettingsId = {
  __typename?: 'UserSettingsId';
  projectId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GetAnalyticsByObjectIdPagedQueryVariables = Exact<{
  input: ByIdAndDateRangeReqInput;
}>;


export type GetAnalyticsByObjectIdPagedQuery = { __typename?: 'Query', allAnalyticsResultsByObjectIdAndDateRangePaged: { __typename?: 'OffsetPage_AnalyticsResultDTO', items: Array<{ __typename?: 'AnalyticsResultDTO', analyticsDataType: Type, description?: string | null, severity?: SeverityType | null, deviceType?: string | null, mdmDevice?: { __typename?: 'MdmDeviceDTO', identifier?: string | null, id?: string | null, customFields?: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> | null } | null, mdmObject?: { __typename?: 'MdmObjectDTO', title?: string | null, id?: string | null, customFields?: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> | null } | null, id?: { __typename?: 'AnalyticsResultId', analyticsType: string, date: any } | null } | null>, pageInfo?: { __typename?: 'OffsetPageInfo', skip: number, take: number, total?: number | null } | null } };

export type GetAnalyticsByProjectIdPagedQueryVariables = Exact<{
  input: ByIdAndDateRangeReqInput;
}>;


export type GetAnalyticsByProjectIdPagedQuery = { __typename?: 'Query', allAnalyticsResultsByProjectIdAndDateRangePaged: { __typename?: 'OffsetPage_AnalyticsResultDTO', items: Array<{ __typename?: 'AnalyticsResultDTO', analyticsDataType: Type, description?: string | null, severity?: SeverityType | null, deviceType?: string | null, mdmDevice?: { __typename?: 'MdmDeviceDTO', identifier?: string | null, id?: string | null, customFields?: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> | null } | null, id?: { __typename?: 'AnalyticsResultId', analyticsType: string, date: any } | null, mdmObject?: { __typename?: 'MdmObjectDTO', title?: string | null, id?: string | null, address?: { __typename?: 'Address', fullAddress: string } | null, customFields?: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> | null } | null } | null>, pageInfo?: { __typename?: 'OffsetPageInfo', skip: number, take: number, total?: number | null } | null } };

export type GetAnalyticsHeatmapByProjectIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  range: InstantRangeDtoInput;
}>;


export type GetAnalyticsHeatmapByProjectIdQuery = { __typename?: 'Query', analyticsHeatmapByProjectIdAndDateRange: Array<{ __typename?: 'HeatData', date?: any | null, value?: any | null }> };

export type GetAnalyticsHeatmapByObjectIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  range: InstantRangeDtoInput;
}>;


export type GetAnalyticsHeatmapByObjectIdQuery = { __typename?: 'Query', analyticsHeatmapByObjectIdAndDateRange: Array<{ __typename?: 'HeatData', date?: any | null, value?: any | null }> };

export type GetDevicesPagedQueryVariables = Exact<{
  input: ByProjectIdReqInput;
}>;


export type GetDevicesPagedQuery = { __typename?: 'Query', mdmDevicesByProjectIdPaged: { __typename?: 'OffsetPage_MdmDeviceDTO', items: Array<{ __typename?: 'MdmDeviceDTO', id?: string | null, identifier?: string | null, tags?: Array<string | null> | null, datasetCount: number, status: { __typename?: 'MdmDeviceStatusDTO', status: DeviceStatus, lastMeasurementDate?: any | null }, lastMeasurements: Array<{ __typename?: 'DeviceMeasurement', mapping?: string | null, value: number } | null>, config?: { __typename?: 'MdmDeviceConfigDTO', title?: string | null } | null, customFields?: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> | null, boundDatasets: { __typename?: 'BoundDatasets', mapped: Array<{ __typename?: 'BoundDatasetsDeviceMapping', mapping: string, dataset?: { __typename?: 'DatasetInfo', identifier?: string | null } | null } | null> }, objectRelation?: { __typename?: 'MdmObjectDeviceRelationDTO', roleInObject?: string | null, roleIdentifier?: string | null, mdmObject?: { __typename?: 'MdmObjectDTO', id?: string | null, title?: string | null, identifier?: string | null, address?: { __typename?: 'Address', fullAddress: string } | null, location?: { __typename?: 'Location', latitude?: number | null, longitude?: number | null } | null } | null } | null } | null>, pageInfo?: { __typename?: 'OffsetPageInfo', skip: number, take: number, total?: number | null } | null } };

export type GetAllDevicesByProjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAllDevicesByProjectQuery = { __typename?: 'Query', mdmDevicesByProjectId: Array<{ __typename?: 'MdmDeviceDTO', status: { __typename?: 'MdmDeviceStatusDTO', status: DeviceStatus }, objectRelation?: { __typename?: 'MdmObjectDeviceRelationDTO', mdmObject?: { __typename?: 'MdmObjectDTO', id?: string | null } | null } | null }> };

export type GetDeviceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDeviceQuery = { __typename?: 'Query', mdmDeviceById?: { __typename?: 'MdmDeviceDTO', id?: string | null, identifier?: string | null, tags?: Array<string | null> | null, createdAt?: any | null, modifiedAt?: any | null, status: { __typename?: 'MdmDeviceStatusDTO', status: DeviceStatus, lastMeasurementDate?: any | null }, boundDatasets: { __typename?: 'BoundDatasets', all: Array<{ __typename?: 'DatasetInfo', identifier?: string | null, title?: string | null } | null>, mapped: Array<{ __typename?: 'BoundDatasetsDeviceMapping', mapping: string, dataset?: { __typename?: 'DatasetInfo', identifier?: string | null, title?: string | null } | null } | null> }, customFields?: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> | null, config?: { __typename?: 'MdmDeviceConfigDTO', id?: string | null, title?: string | null, projectId?: string | null, vitalityThreshold?: number | null, measurementMappings: Array<{ __typename?: 'MeasurementMappingInput', key: string, value: Array<string | null> } | null> } | null, objectRelation?: { __typename?: 'MdmObjectDeviceRelationDTO', roleInObject?: string | null, roleIdentifier?: string | null, mdmObject?: { __typename?: 'MdmObjectDTO', id?: string | null, title?: string | null, identifier?: string | null, address?: { __typename?: 'Address', fullAddress: string } | null } | null } | null, history?: Array<{ __typename?: 'MdmDeviceHistory', address: string, timestamp: any, objectId?: string | null, objectIdentifier: string, value: number } | null> | null } | null };

export type GetDeviceStatusRecordsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDeviceStatusRecordsQuery = { __typename?: 'Query', mdmDeviceStatusRecords: Array<{ __typename?: 'MdmDeviceStatusDTO', status: DeviceStatus, timestamp: any }> };

export type CreateDeviceMutationVariables = Exact<{
  device: MdmDeviceDtoInput;
  objectId: Scalars['String']['input'];
}>;


export type CreateDeviceMutation = { __typename?: 'Mutation', createMdmDevice: { __typename?: 'MdmDeviceDTO', id?: string | null, identifier?: string | null, tags?: Array<string | null> | null, modifiedAt?: any | null, createdAt?: any | null, objectRelation?: { __typename?: 'MdmObjectDeviceRelationDTO', mdmObject?: { __typename?: 'MdmObjectDTO', id?: string | null, title?: string | null, identifier?: string | null } | null } | null, config?: { __typename?: 'MdmDeviceConfigDTO', id?: string | null, vitalityThreshold?: number | null } | null, boundDatasets: { __typename?: 'BoundDatasets', all: Array<{ __typename?: 'DatasetInfo', identifier?: string | null } | null> } } };

export type UpdateDeviceMutationVariables = Exact<{
  device: MdmDeviceDtoInput;
  objectId: Scalars['String']['input'];
}>;


export type UpdateDeviceMutation = { __typename?: 'Mutation', updateMdmDevice: { __typename?: 'MdmDeviceDTO', id?: string | null, identifier?: string | null, tags?: Array<string | null> | null, objectRelation?: { __typename?: 'MdmObjectDeviceRelationDTO', mdmObject?: { __typename?: 'MdmObjectDTO', id?: string | null, identifier?: string | null } | null } | null, config?: { __typename?: 'MdmDeviceConfigDTO', id?: string | null } | null } };

export type DeleteDeviceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDeviceMutation = { __typename?: 'Mutation', deleteMdmDevice: { __typename?: 'MdmDeviceDTO', id?: string | null, modifiedAt?: any | null, createdAt?: any | null, config?: { __typename?: 'MdmDeviceConfigDTO', id?: string | null } | null, boundDatasets: { __typename?: 'BoundDatasets', all: Array<{ __typename?: 'DatasetInfo', identifier?: string | null } | null> } } };

export type UpdateDeviceRelationMutationVariables = Exact<{
  input: MdmObjectDeviceRelationDtoInput;
}>;


export type UpdateDeviceRelationMutation = { __typename?: 'Mutation', updateObjectDeviceRelation?: { __typename?: 'MdmObjectDeviceRelationDTO', roleInObject?: string | null, roleIdentifier?: string | null, mdmDevice?: { __typename?: 'MdmDeviceDTO', id?: string | null } | null } | null };

export type GetJobsByObjectIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetJobsByObjectIdQuery = { __typename?: 'Query', allJobsByObjectId: Array<{ __typename?: 'MdmObjectJobDTO', id?: any | null, description?: string | null, createdBy?: string | null, severity?: SeverityType | null, title?: string | null, startDate?: any | null, endDate?: any | null, status?: StatusType | null, createdByUsername: string, mdmObject?: { __typename?: 'MdmObject', id?: string | null, title?: string | null, customFields: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> } | null }> };

export type GetJobsByProjectIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetJobsByProjectIdQuery = { __typename?: 'Query', allJobsByProjectId: Array<{ __typename?: 'MdmObjectJobDTO', id?: any | null, description?: string | null, createdBy?: string | null, severity?: SeverityType | null, title?: string | null, startDate?: any | null, endDate?: any | null, status?: StatusType | null, createdByUsername: string, mdmObject?: { __typename?: 'MdmObject', id?: string | null, title?: string | null, customFields: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> } | null }> };

export type GetJobByIdQueryVariables = Exact<{
  id: Scalars['BigInteger']['input'];
}>;


export type GetJobByIdQuery = { __typename?: 'Query', jobById: { __typename?: 'MdmObjectJobDTO', id?: any | null, description?: string | null, createdBy?: string | null, severity?: SeverityType | null, title?: string | null, startDate?: any | null, endDate?: any | null, status?: StatusType | null } };

export type CreateJobMutationVariables = Exact<{
  objectId: Scalars['String']['input'];
  input: MdmObjectJobDtoInput;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'MdmObjectJobDTO', id?: any | null, description?: string | null, createdBy?: string | null, severity?: SeverityType | null, title?: string | null, startDate?: any | null, endDate?: any | null, status?: StatusType | null } };

export type UpdateJobMutationVariables = Exact<{
  input: MdmObjectJobDtoInput;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'MdmObjectJobDTO', id?: any | null, description?: string | null, createdBy?: string | null, severity?: SeverityType | null, title?: string | null, startDate?: any | null, endDate?: any | null, status?: StatusType | null } };

export type DeleteJobMutationVariables = Exact<{
  jobId: Scalars['BigInteger']['input'];
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob: { __typename?: 'MdmObjectJobDTO', id?: any | null } };

export type GetAllNotesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAllNotesQuery = { __typename?: 'Query', allNotesByObjectId: Array<{ __typename?: 'MdmObjectNoteDTO', note?: string | null, id?: any | null, createdAt?: any | null, modifiedAt?: any | null, createdByUsername: string, modifiedByUsername: string }> };

export type CreateNoteMutationVariables = Exact<{
  objectId: Scalars['String']['input'];
  note: Scalars['String']['input'];
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'MdmObjectNoteDTO', modifiedAt?: any | null, createdAt?: any | null, id?: any | null, note?: string | null, createdByUsername: string } };

export type UpdateNoteMutationVariables = Exact<{
  note: MdmObjectNoteDtoInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'MdmObjectNoteDTO', modifiedAt?: any | null, createdAt?: any | null, id?: any | null, note?: string | null, createdByUsername: string, modifiedByUsername: string } };

export type DeleteNoteMutationVariables = Exact<{
  id: Scalars['BigInteger']['input'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: { __typename?: 'MdmObjectNoteDTO', id?: any | null } };

export type GetObjectsPagedQueryVariables = Exact<{
  input: ByProjectIdReqInput;
}>;


export type GetObjectsPagedQuery = { __typename?: 'Query', mdmObjectsByProjectIdPaged: { __typename?: 'OffsetPage_MdmObjectDTO', items: Array<{ __typename?: 'MdmObjectDTO', id?: string | null, tags?: Array<string | null> | null, title?: string | null, identifier?: string | null, address?: { __typename?: 'Address', fullAddress: string } | null, location?: { __typename?: 'Location', latitude?: number | null, longitude?: number | null } | null, customFields?: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> | null } | null>, pageInfo?: { __typename?: 'OffsetPageInfo', skip: number, take: number, total?: number | null } | null } };

export type GetObjectsByProjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetObjectsByProjectQuery = { __typename?: 'Query', mdmObjectsByProjectId: Array<{ __typename?: 'MdmObjectDTO', id?: string | null, identifier?: string | null }> };

export type GetObjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetObjectQuery = { __typename?: 'Query', mdmObjectById: { __typename?: 'MdmObjectDTO', description?: string | null, id?: string | null, tags?: Array<string | null> | null, title?: string | null, identifier?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, houseNumber?: string | null, postCode?: string | null, street?: string | null, fullAddress: string } | null, customFields?: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> | null, boundDatasets: { __typename?: 'BoundDatasetsObject', all: Array<{ __typename?: 'BoundDatasetsObjectMapping', dataset?: { __typename?: 'DatasetInfo', identifier?: string | null, title?: string | null } | null } | null>, indirect: Array<{ __typename?: 'BoundDatasetsObjectMapping', dataset?: { __typename?: 'DatasetInfo', identifier?: string | null, title?: string | null } | null } | null>, direct: Array<{ __typename?: 'BoundDatasetsObjectMapping', dataset?: { __typename?: 'DatasetInfo', identifier?: string | null, title?: string | null } | null } | null>, mapped: Array<{ __typename?: 'BoundDatasetsObjectMapping', dataset?: { __typename?: 'DatasetInfo', identifier?: string | null, title?: string | null } | null } | null> }, deviceRelations: Array<{ __typename?: 'MdmObjectDeviceRelationDTO', roleInObject?: string | null, mdmDevice?: { __typename?: 'MdmDeviceDTO', id?: string | null, identifier?: string | null, tags?: Array<string | null> | null, modifiedAt?: any | null, createdAt?: any | null, status: { __typename?: 'MdmDeviceStatusDTO', status: DeviceStatus, lastMeasurementDate?: any | null }, customFields?: Array<{ __typename?: 'Entry_String_AttributeData_String', key?: string | null, value?: { __typename?: 'AttributeData_String', type: AttributeType, value?: string | null } | null } | null> | null } | null }>, location?: { __typename?: 'Location', latitude?: number | null, longitude?: number | null } | null, info: { __typename?: 'MdmObjectInfo', jobsCount: number, notesCount: number } } };

export type CreateObjectMutationVariables = Exact<{
  object: MdmObjectDtoInput;
}>;


export type CreateObjectMutation = { __typename?: 'Mutation', createMdmObject: { __typename?: 'MdmObjectDTO', id?: string | null, title?: string | null, identifier?: string | null, description?: string | null, tags?: Array<string | null> | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, houseNumber?: string | null, postCode?: string | null, street?: string | null } | null, location?: { __typename?: 'Location', latitude?: number | null, longitude?: number | null } | null } };

export type UpdateObjectMutationVariables = Exact<{
  object: MdmObjectDtoInput;
}>;


export type UpdateObjectMutation = { __typename?: 'Mutation', updateMdmObject: { __typename?: 'MdmObjectDTO', id?: string | null, title?: string | null, identifier?: string | null, description?: string | null, tags?: Array<string | null> | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, houseNumber?: string | null, postCode?: string | null, street?: string | null } | null, location?: { __typename?: 'Location', latitude?: number | null, longitude?: number | null } | null } };

export type DeleteObjectMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteObjectMutation = { __typename?: 'Mutation', deleteMdmObject: { __typename?: 'MdmObjectDTO', id?: string | null, identifier?: string | null, title?: string | null } };

export type GetProjectsByCompanyQueryVariables = Exact<{
  refName: Scalars['String']['input'];
}>;


export type GetProjectsByCompanyQuery = { __typename?: 'Query', mdmProjectsByCompany: Array<{ __typename?: 'MdmProjectDTO', id?: string | null, title?: string | null } | null> };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', mdmProjectById: { __typename?: 'MdmProjectDTO', companyReference?: string | null, id?: string | null, title?: string | null, datasetMode?: DatasetMode | null, filterInfo: { __typename?: 'FilterInfo', allFields: Array<{ __typename?: 'Field', containerType: string, fieldType?: string | null, key: string, label: string, inputType?: FilterValueType | null, leaf: boolean, enum?: Array<{ __typename?: 'EnumItem', key: string, label: string } | null> | null } | null>, allOperators: Array<{ __typename?: 'Op', key: string, label: string } | null> }, deviceConfigs?: Array<{ __typename?: 'MdmDeviceConfigDTO', id?: string | null, title?: string | null, vitalityThreshold?: number | null, measurementMappings: Array<{ __typename?: 'MeasurementMappingInput', key: string, value: Array<string | null> } | null> } | null> | null, configuration?: { __typename?: 'MdmProjectConfiguration', analyticsConfiguration: { __typename?: 'AnalyticsConfiguration', dataTypes: Array<{ __typename?: 'AnalyticsDataType', name: string } | null>, resultTypes: Array<{ __typename?: 'AnalyticsResultType', type: string } | null> }, objectConfiguration: { __typename?: 'ObjectsConfiguration', customFields: Array<{ __typename?: 'Attribute', id: string, parent?: Array<string | null> | null, title: string, type: AttributeType, enums?: Array<string | null> | null, reading?: string | null } | null> }, deviceConfiguration: { __typename?: 'DevicesConfiguration', customFields: Array<{ __typename?: 'Attribute', id: string, parent?: Array<string | null> | null, title: string, type: AttributeType, enums?: Array<string | null> | null, reading?: string | null } | null>, measurementTypes?: Array<{ __typename?: 'MeasurementTypeDef', id: string, title: string } | null> | null } } | null } };

export type CreateProjectMutationVariables = Exact<{
  project: MdmProjectInputInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createMdmProject: { __typename?: 'MdmProjectDTO', id?: string | null, title?: string | null, companyReference?: string | null, datasetMode?: DatasetMode | null, configuration?: { __typename?: 'MdmProjectConfiguration', analyticsConfiguration: { __typename?: 'AnalyticsConfiguration', dataTypes: Array<{ __typename?: 'AnalyticsDataType', name: string } | null>, resultTypes: Array<{ __typename?: 'AnalyticsResultType', type: string } | null> }, objectConfiguration: { __typename?: 'ObjectsConfiguration', customFields: Array<{ __typename?: 'Attribute', id: string, parent?: Array<string | null> | null, title: string, type: AttributeType } | null> }, deviceConfiguration: { __typename?: 'DevicesConfiguration', customFields: Array<{ __typename?: 'Attribute', id: string, parent?: Array<string | null> | null, title: string, type: AttributeType } | null>, measurementTypes?: Array<{ __typename?: 'MeasurementTypeDef', id: string, title: string } | null> | null } } | null } };

export type UpdateProjectMutationVariables = Exact<{
  project: MdmProjectDtoInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateMdmProject: { __typename?: 'MdmProjectDTO', companyReference?: string | null, id?: string | null, title?: string | null, datasetMode?: DatasetMode | null, deviceConfigs?: Array<{ __typename?: 'MdmDeviceConfigDTO', id?: string | null, title?: string | null, vitalityThreshold?: number | null, measurementMappings: Array<{ __typename?: 'MeasurementMappingInput', key: string, value: Array<string | null> } | null> } | null> | null, configuration?: { __typename?: 'MdmProjectConfiguration', analyticsConfiguration: { __typename?: 'AnalyticsConfiguration', dataTypes: Array<{ __typename?: 'AnalyticsDataType', name: string } | null>, resultTypes: Array<{ __typename?: 'AnalyticsResultType', type: string } | null> }, objectConfiguration: { __typename?: 'ObjectsConfiguration', customFields: Array<{ __typename?: 'Attribute', id: string, parent?: Array<string | null> | null, title: string, type: AttributeType, enums?: Array<string | null> | null } | null> }, deviceConfiguration: { __typename?: 'DevicesConfiguration', customFields: Array<{ __typename?: 'Attribute', id: string, parent?: Array<string | null> | null, title: string, type: AttributeType, enums?: Array<string | null> | null } | null>, measurementTypes?: Array<{ __typename?: 'MeasurementTypeDef', id: string, title: string } | null> | null } } | null } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteMdmProject: { __typename?: 'MdmProjectDTO', id?: string | null, title?: string | null } };

export type CreateUpdateDeviceConfigurationMutationVariables = Exact<{
  input: MdmDeviceConfigDtoInput;
}>;


export type CreateUpdateDeviceConfigurationMutation = { __typename?: 'Mutation', createUpdateDeviceConfig: { __typename?: 'MdmDeviceConfigDTO', id?: string | null, title?: string | null, vitalityThreshold?: number | null, measurementMappings: Array<{ __typename?: 'MeasurementMappingInput', key: string, value: Array<string | null> } | null> } };

export type DeleteDeviceConfigurationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteDeviceConfigurationMutation = { __typename?: 'Mutation', deleteDeviceConfig: { __typename?: 'MdmDeviceConfigDTO', id?: string | null } };

export type GetCoordinatesQueryVariables = Exact<{
  address: AddressInput;
}>;


export type GetCoordinatesQuery = { __typename?: 'Query', coordinates: Array<{ __typename?: 'OpenStreetAddress', latitude: number, longitude: number } | null> };

export type GetUserSettingsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserSettingsQuery = { __typename?: 'Query', userSettings: { __typename?: 'UserSettingsDto', id?: { __typename?: 'UserSettingsId', projectId?: string | null, userId?: string | null } | null, tableFilters?: Array<{ __typename?: 'TableFilter', id?: string | null, title: string, tableName: string, andFilters: Array<{ __typename?: 'AndFilter', cond: FilterOp, property: string, value?: string | null } | null> } | null> | null, tablesDetails?: Array<{ __typename?: 'TablesDetails', rows: number, table: string, columnOrders: Array<{ __typename?: 'ColumnOrder', name: string, order: number } | null> } | null> | null } };

export type UpdateTableDetailsForUserMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  tableDetails: TablesDetailsInput;
}>;


export type UpdateTableDetailsForUserMutation = { __typename?: 'Mutation', updateTableDetailsForUser: { __typename?: 'UserSettingsDto', id?: { __typename?: 'UserSettingsId', projectId?: string | null, userId?: string | null } | null, tablesDetails?: Array<{ __typename?: 'TablesDetails', rows: number, table: string, columnOrders: Array<{ __typename?: 'ColumnOrder', name: string, order: number } | null> } | null> | null } };

export type UpdateTableFiltersMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  tableFilter: TableFilterInput;
}>;


export type UpdateTableFiltersMutation = { __typename?: 'Mutation', updateTableFilters: { __typename?: 'UserSettingsDto', id?: { __typename?: 'UserSettingsId', projectId?: string | null, userId?: string | null } | null, tableFilters?: Array<{ __typename?: 'TableFilter', id?: string | null, title: string, andFilters: Array<{ __typename?: 'AndFilter', cond: FilterOp, property: string, value?: string | null } | null> } | null> | null } };

export type DeleteTableFilterMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  filterId: Scalars['String']['input'];
}>;


export type DeleteTableFilterMutation = { __typename?: 'Mutation', deleteTableFilter: { __typename?: 'UserSettingsDto', id?: { __typename?: 'UserSettingsId', projectId?: string | null, userId?: string | null } | null } };


export const GetAnalyticsByObjectIdPagedDocument = gql`
    query GetAnalyticsByObjectIdPaged($input: ByIdAndDateRangeReqInput!) {
  allAnalyticsResultsByObjectIdAndDateRangePaged(req: $input) {
    items {
      analyticsDataType
      description
      mdmDevice {
        identifier
        id
        customFields {
          key
          value {
            type
            value
          }
        }
      }
      mdmObject {
        title
        id
        customFields {
          key
          value {
            type
            value
          }
        }
      }
      severity
      deviceType
      id {
        analyticsType
        date
      }
    }
    pageInfo {
      skip
      take
      total
    }
  }
}
    `;

/**
 * __useGetAnalyticsByObjectIdPagedQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsByObjectIdPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsByObjectIdPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsByObjectIdPagedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAnalyticsByObjectIdPagedQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsByObjectIdPagedQuery, GetAnalyticsByObjectIdPagedQueryVariables> & ({ variables: GetAnalyticsByObjectIdPagedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsByObjectIdPagedQuery, GetAnalyticsByObjectIdPagedQueryVariables>(GetAnalyticsByObjectIdPagedDocument, options);
      }
export function useGetAnalyticsByObjectIdPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsByObjectIdPagedQuery, GetAnalyticsByObjectIdPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsByObjectIdPagedQuery, GetAnalyticsByObjectIdPagedQueryVariables>(GetAnalyticsByObjectIdPagedDocument, options);
        }
export function useGetAnalyticsByObjectIdPagedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsByObjectIdPagedQuery, GetAnalyticsByObjectIdPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsByObjectIdPagedQuery, GetAnalyticsByObjectIdPagedQueryVariables>(GetAnalyticsByObjectIdPagedDocument, options);
        }
export type GetAnalyticsByObjectIdPagedQueryHookResult = ReturnType<typeof useGetAnalyticsByObjectIdPagedQuery>;
export type GetAnalyticsByObjectIdPagedLazyQueryHookResult = ReturnType<typeof useGetAnalyticsByObjectIdPagedLazyQuery>;
export type GetAnalyticsByObjectIdPagedSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsByObjectIdPagedSuspenseQuery>;
export type GetAnalyticsByObjectIdPagedQueryResult = Apollo.QueryResult<GetAnalyticsByObjectIdPagedQuery, GetAnalyticsByObjectIdPagedQueryVariables>;
export const GetAnalyticsByProjectIdPagedDocument = gql`
    query GetAnalyticsByProjectIdPaged($input: ByIdAndDateRangeReqInput!) {
  allAnalyticsResultsByProjectIdAndDateRangePaged(req: $input) {
    items {
      analyticsDataType
      description
      mdmDevice {
        identifier
        id
        customFields {
          key
          value {
            type
            value
          }
        }
      }
      severity
      deviceType
      id {
        analyticsType
        date
      }
      mdmObject {
        title
        id
        address {
          fullAddress
        }
        customFields {
          key
          value {
            type
            value
          }
        }
      }
    }
    pageInfo {
      skip
      take
      total
    }
  }
}
    `;

/**
 * __useGetAnalyticsByProjectIdPagedQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsByProjectIdPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsByProjectIdPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsByProjectIdPagedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAnalyticsByProjectIdPagedQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsByProjectIdPagedQuery, GetAnalyticsByProjectIdPagedQueryVariables> & ({ variables: GetAnalyticsByProjectIdPagedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsByProjectIdPagedQuery, GetAnalyticsByProjectIdPagedQueryVariables>(GetAnalyticsByProjectIdPagedDocument, options);
      }
export function useGetAnalyticsByProjectIdPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsByProjectIdPagedQuery, GetAnalyticsByProjectIdPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsByProjectIdPagedQuery, GetAnalyticsByProjectIdPagedQueryVariables>(GetAnalyticsByProjectIdPagedDocument, options);
        }
export function useGetAnalyticsByProjectIdPagedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsByProjectIdPagedQuery, GetAnalyticsByProjectIdPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsByProjectIdPagedQuery, GetAnalyticsByProjectIdPagedQueryVariables>(GetAnalyticsByProjectIdPagedDocument, options);
        }
export type GetAnalyticsByProjectIdPagedQueryHookResult = ReturnType<typeof useGetAnalyticsByProjectIdPagedQuery>;
export type GetAnalyticsByProjectIdPagedLazyQueryHookResult = ReturnType<typeof useGetAnalyticsByProjectIdPagedLazyQuery>;
export type GetAnalyticsByProjectIdPagedSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsByProjectIdPagedSuspenseQuery>;
export type GetAnalyticsByProjectIdPagedQueryResult = Apollo.QueryResult<GetAnalyticsByProjectIdPagedQuery, GetAnalyticsByProjectIdPagedQueryVariables>;
export const GetAnalyticsHeatmapByProjectIdDocument = gql`
    query GetAnalyticsHeatmapByProjectId($id: String!, $range: InstantRangeDTOInput!) {
  analyticsHeatmapByProjectIdAndDateRange(id: $id, range: $range) {
    date
    value
  }
}
    `;

/**
 * __useGetAnalyticsHeatmapByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsHeatmapByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsHeatmapByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsHeatmapByProjectIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetAnalyticsHeatmapByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsHeatmapByProjectIdQuery, GetAnalyticsHeatmapByProjectIdQueryVariables> & ({ variables: GetAnalyticsHeatmapByProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsHeatmapByProjectIdQuery, GetAnalyticsHeatmapByProjectIdQueryVariables>(GetAnalyticsHeatmapByProjectIdDocument, options);
      }
export function useGetAnalyticsHeatmapByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsHeatmapByProjectIdQuery, GetAnalyticsHeatmapByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsHeatmapByProjectIdQuery, GetAnalyticsHeatmapByProjectIdQueryVariables>(GetAnalyticsHeatmapByProjectIdDocument, options);
        }
export function useGetAnalyticsHeatmapByProjectIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsHeatmapByProjectIdQuery, GetAnalyticsHeatmapByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsHeatmapByProjectIdQuery, GetAnalyticsHeatmapByProjectIdQueryVariables>(GetAnalyticsHeatmapByProjectIdDocument, options);
        }
export type GetAnalyticsHeatmapByProjectIdQueryHookResult = ReturnType<typeof useGetAnalyticsHeatmapByProjectIdQuery>;
export type GetAnalyticsHeatmapByProjectIdLazyQueryHookResult = ReturnType<typeof useGetAnalyticsHeatmapByProjectIdLazyQuery>;
export type GetAnalyticsHeatmapByProjectIdSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsHeatmapByProjectIdSuspenseQuery>;
export type GetAnalyticsHeatmapByProjectIdQueryResult = Apollo.QueryResult<GetAnalyticsHeatmapByProjectIdQuery, GetAnalyticsHeatmapByProjectIdQueryVariables>;
export const GetAnalyticsHeatmapByObjectIdDocument = gql`
    query GetAnalyticsHeatmapByObjectId($id: String!, $range: InstantRangeDTOInput!) {
  analyticsHeatmapByObjectIdAndDateRange(id: $id, range: $range) {
    date
    value
  }
}
    `;

/**
 * __useGetAnalyticsHeatmapByObjectIdQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsHeatmapByObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsHeatmapByObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsHeatmapByObjectIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetAnalyticsHeatmapByObjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsHeatmapByObjectIdQuery, GetAnalyticsHeatmapByObjectIdQueryVariables> & ({ variables: GetAnalyticsHeatmapByObjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsHeatmapByObjectIdQuery, GetAnalyticsHeatmapByObjectIdQueryVariables>(GetAnalyticsHeatmapByObjectIdDocument, options);
      }
export function useGetAnalyticsHeatmapByObjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsHeatmapByObjectIdQuery, GetAnalyticsHeatmapByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsHeatmapByObjectIdQuery, GetAnalyticsHeatmapByObjectIdQueryVariables>(GetAnalyticsHeatmapByObjectIdDocument, options);
        }
export function useGetAnalyticsHeatmapByObjectIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyticsHeatmapByObjectIdQuery, GetAnalyticsHeatmapByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsHeatmapByObjectIdQuery, GetAnalyticsHeatmapByObjectIdQueryVariables>(GetAnalyticsHeatmapByObjectIdDocument, options);
        }
export type GetAnalyticsHeatmapByObjectIdQueryHookResult = ReturnType<typeof useGetAnalyticsHeatmapByObjectIdQuery>;
export type GetAnalyticsHeatmapByObjectIdLazyQueryHookResult = ReturnType<typeof useGetAnalyticsHeatmapByObjectIdLazyQuery>;
export type GetAnalyticsHeatmapByObjectIdSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsHeatmapByObjectIdSuspenseQuery>;
export type GetAnalyticsHeatmapByObjectIdQueryResult = Apollo.QueryResult<GetAnalyticsHeatmapByObjectIdQuery, GetAnalyticsHeatmapByObjectIdQueryVariables>;
export const GetDevicesPagedDocument = gql`
    query GetDevicesPaged($input: ByProjectIdReqInput!) {
  mdmDevicesByProjectIdPaged(req: $input) {
    items {
      id
      identifier
      status {
        status
        lastMeasurementDate
      }
      lastMeasurements {
        mapping
        value
      }
      tags
      config {
        title
      }
      customFields {
        key
        value {
          type
          value
        }
      }
      datasetCount
      boundDatasets {
        mapped {
          mapping
          dataset {
            identifier
          }
        }
      }
      objectRelation {
        mdmObject {
          id
          title
          identifier
          address {
            fullAddress
          }
          location {
            latitude
            longitude
          }
        }
        roleInObject
        roleIdentifier
      }
    }
    pageInfo {
      skip
      take
      total
    }
  }
}
    `;

/**
 * __useGetDevicesPagedQuery__
 *
 * To run a query within a React component, call `useGetDevicesPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevicesPagedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDevicesPagedQuery(baseOptions: Apollo.QueryHookOptions<GetDevicesPagedQuery, GetDevicesPagedQueryVariables> & ({ variables: GetDevicesPagedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevicesPagedQuery, GetDevicesPagedQueryVariables>(GetDevicesPagedDocument, options);
      }
export function useGetDevicesPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevicesPagedQuery, GetDevicesPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevicesPagedQuery, GetDevicesPagedQueryVariables>(GetDevicesPagedDocument, options);
        }
export function useGetDevicesPagedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDevicesPagedQuery, GetDevicesPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDevicesPagedQuery, GetDevicesPagedQueryVariables>(GetDevicesPagedDocument, options);
        }
export type GetDevicesPagedQueryHookResult = ReturnType<typeof useGetDevicesPagedQuery>;
export type GetDevicesPagedLazyQueryHookResult = ReturnType<typeof useGetDevicesPagedLazyQuery>;
export type GetDevicesPagedSuspenseQueryHookResult = ReturnType<typeof useGetDevicesPagedSuspenseQuery>;
export type GetDevicesPagedQueryResult = Apollo.QueryResult<GetDevicesPagedQuery, GetDevicesPagedQueryVariables>;
export const GetAllDevicesByProjectDocument = gql`
    query GetAllDevicesByProject($id: String!) {
  mdmDevicesByProjectId(projectId: $id) {
    status {
      status
    }
    objectRelation {
      mdmObject {
        id
      }
    }
  }
}
    `;

/**
 * __useGetAllDevicesByProjectQuery__
 *
 * To run a query within a React component, call `useGetAllDevicesByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDevicesByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDevicesByProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllDevicesByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetAllDevicesByProjectQuery, GetAllDevicesByProjectQueryVariables> & ({ variables: GetAllDevicesByProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDevicesByProjectQuery, GetAllDevicesByProjectQueryVariables>(GetAllDevicesByProjectDocument, options);
      }
export function useGetAllDevicesByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDevicesByProjectQuery, GetAllDevicesByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDevicesByProjectQuery, GetAllDevicesByProjectQueryVariables>(GetAllDevicesByProjectDocument, options);
        }
export function useGetAllDevicesByProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllDevicesByProjectQuery, GetAllDevicesByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDevicesByProjectQuery, GetAllDevicesByProjectQueryVariables>(GetAllDevicesByProjectDocument, options);
        }
export type GetAllDevicesByProjectQueryHookResult = ReturnType<typeof useGetAllDevicesByProjectQuery>;
export type GetAllDevicesByProjectLazyQueryHookResult = ReturnType<typeof useGetAllDevicesByProjectLazyQuery>;
export type GetAllDevicesByProjectSuspenseQueryHookResult = ReturnType<typeof useGetAllDevicesByProjectSuspenseQuery>;
export type GetAllDevicesByProjectQueryResult = Apollo.QueryResult<GetAllDevicesByProjectQuery, GetAllDevicesByProjectQueryVariables>;
export const GetDeviceDocument = gql`
    query GetDevice($id: String!) {
  mdmDeviceById(id: $id) {
    id
    identifier
    tags
    status {
      status
      lastMeasurementDate
    }
    boundDatasets {
      all {
        identifier
        title
      }
      mapped {
        dataset {
          identifier
          title
        }
        mapping
      }
    }
    customFields {
      key
      value {
        type
        value
      }
    }
    createdAt
    modifiedAt
    config {
      id
      title
      projectId
      vitalityThreshold
      measurementMappings {
        key
        value
      }
    }
    objectRelation {
      mdmObject {
        id
        title
        identifier
        address {
          fullAddress
        }
      }
      roleInObject
      roleIdentifier
    }
    history {
      address
      timestamp
      objectId
      objectIdentifier
      value
    }
  }
}
    `;

/**
 * __useGetDeviceQuery__
 *
 * To run a query within a React component, call `useGetDeviceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeviceQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceQuery, GetDeviceQueryVariables> & ({ variables: GetDeviceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceQuery, GetDeviceQueryVariables>(GetDeviceDocument, options);
      }
export function useGetDeviceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceQuery, GetDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceQuery, GetDeviceQueryVariables>(GetDeviceDocument, options);
        }
export function useGetDeviceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeviceQuery, GetDeviceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeviceQuery, GetDeviceQueryVariables>(GetDeviceDocument, options);
        }
export type GetDeviceQueryHookResult = ReturnType<typeof useGetDeviceQuery>;
export type GetDeviceLazyQueryHookResult = ReturnType<typeof useGetDeviceLazyQuery>;
export type GetDeviceSuspenseQueryHookResult = ReturnType<typeof useGetDeviceSuspenseQuery>;
export type GetDeviceQueryResult = Apollo.QueryResult<GetDeviceQuery, GetDeviceQueryVariables>;
export const GetDeviceStatusRecordsDocument = gql`
    query GetDeviceStatusRecords($id: String!) {
  mdmDeviceStatusRecords(deviceId: $id) {
    status
    timestamp
  }
}
    `;

/**
 * __useGetDeviceStatusRecordsQuery__
 *
 * To run a query within a React component, call `useGetDeviceStatusRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceStatusRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceStatusRecordsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDeviceStatusRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetDeviceStatusRecordsQuery, GetDeviceStatusRecordsQueryVariables> & ({ variables: GetDeviceStatusRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeviceStatusRecordsQuery, GetDeviceStatusRecordsQueryVariables>(GetDeviceStatusRecordsDocument, options);
      }
export function useGetDeviceStatusRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeviceStatusRecordsQuery, GetDeviceStatusRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeviceStatusRecordsQuery, GetDeviceStatusRecordsQueryVariables>(GetDeviceStatusRecordsDocument, options);
        }
export function useGetDeviceStatusRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeviceStatusRecordsQuery, GetDeviceStatusRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeviceStatusRecordsQuery, GetDeviceStatusRecordsQueryVariables>(GetDeviceStatusRecordsDocument, options);
        }
export type GetDeviceStatusRecordsQueryHookResult = ReturnType<typeof useGetDeviceStatusRecordsQuery>;
export type GetDeviceStatusRecordsLazyQueryHookResult = ReturnType<typeof useGetDeviceStatusRecordsLazyQuery>;
export type GetDeviceStatusRecordsSuspenseQueryHookResult = ReturnType<typeof useGetDeviceStatusRecordsSuspenseQuery>;
export type GetDeviceStatusRecordsQueryResult = Apollo.QueryResult<GetDeviceStatusRecordsQuery, GetDeviceStatusRecordsQueryVariables>;
export const CreateDeviceDocument = gql`
    mutation CreateDevice($device: MdmDeviceDTOInput!, $objectId: String!) {
  createMdmDevice(input: $device, objectId: $objectId) {
    id
    identifier
    tags
    objectRelation {
      mdmObject {
        id
        title
        identifier
      }
    }
    config {
      id
      vitalityThreshold
    }
    boundDatasets {
      all {
        identifier
      }
    }
    modifiedAt
    createdAt
  }
}
    `;
export type CreateDeviceMutationFn = Apollo.MutationFunction<CreateDeviceMutation, CreateDeviceMutationVariables>;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      device: // value for 'device'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useCreateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviceMutation, CreateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviceMutation, CreateDeviceMutationVariables>(CreateDeviceDocument, options);
      }
export type CreateDeviceMutationHookResult = ReturnType<typeof useCreateDeviceMutation>;
export type CreateDeviceMutationResult = Apollo.MutationResult<CreateDeviceMutation>;
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<CreateDeviceMutation, CreateDeviceMutationVariables>;
export const UpdateDeviceDocument = gql`
    mutation UpdateDevice($device: MdmDeviceDTOInput!, $objectId: String!) {
  updateMdmDevice(input: $device, objectId: $objectId) {
    id
    identifier
    tags
    objectRelation {
      mdmObject {
        id
        identifier
      }
    }
    config {
      id
    }
  }
}
    `;
export type UpdateDeviceMutationFn = Apollo.MutationFunction<UpdateDeviceMutation, UpdateDeviceMutationVariables>;

/**
 * __useUpdateDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceMutation, { data, loading, error }] = useUpdateDeviceMutation({
 *   variables: {
 *      device: // value for 'device'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useUpdateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceMutation, UpdateDeviceMutationVariables>(UpdateDeviceDocument, options);
      }
export type UpdateDeviceMutationHookResult = ReturnType<typeof useUpdateDeviceMutation>;
export type UpdateDeviceMutationResult = Apollo.MutationResult<UpdateDeviceMutation>;
export type UpdateDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceMutation, UpdateDeviceMutationVariables>;
export const DeleteDeviceDocument = gql`
    mutation DeleteDevice($id: String!) {
  deleteMdmDevice(id: $id) {
    id
    config {
      id
    }
    boundDatasets {
      all {
        identifier
      }
    }
    modifiedAt
    createdAt
  }
}
    `;
export type DeleteDeviceMutationFn = Apollo.MutationFunction<DeleteDeviceMutation, DeleteDeviceMutationVariables>;

/**
 * __useDeleteDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceMutation, { data, loading, error }] = useDeleteDeviceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceMutation, DeleteDeviceMutationVariables>(DeleteDeviceDocument, options);
      }
export type DeleteDeviceMutationHookResult = ReturnType<typeof useDeleteDeviceMutation>;
export type DeleteDeviceMutationResult = Apollo.MutationResult<DeleteDeviceMutation>;
export type DeleteDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceMutation, DeleteDeviceMutationVariables>;
export const UpdateDeviceRelationDocument = gql`
    mutation UpdateDeviceRelation($input: MdmObjectDeviceRelationDTOInput!) {
  updateObjectDeviceRelation(input: $input) {
    mdmDevice {
      id
    }
    roleInObject
    roleIdentifier
  }
}
    `;
export type UpdateDeviceRelationMutationFn = Apollo.MutationFunction<UpdateDeviceRelationMutation, UpdateDeviceRelationMutationVariables>;

/**
 * __useUpdateDeviceRelationMutation__
 *
 * To run a mutation, you first call `useUpdateDeviceRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeviceRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeviceRelationMutation, { data, loading, error }] = useUpdateDeviceRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeviceRelationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeviceRelationMutation, UpdateDeviceRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeviceRelationMutation, UpdateDeviceRelationMutationVariables>(UpdateDeviceRelationDocument, options);
      }
export type UpdateDeviceRelationMutationHookResult = ReturnType<typeof useUpdateDeviceRelationMutation>;
export type UpdateDeviceRelationMutationResult = Apollo.MutationResult<UpdateDeviceRelationMutation>;
export type UpdateDeviceRelationMutationOptions = Apollo.BaseMutationOptions<UpdateDeviceRelationMutation, UpdateDeviceRelationMutationVariables>;
export const GetJobsByObjectIdDocument = gql`
    query GetJobsByObjectId($id: String!) {
  allJobsByObjectId(id: $id) {
    id
    description
    createdBy
    severity
    title
    startDate
    endDate
    mdmObject {
      id
      title
      customFields {
        key
        value {
          type
          value
        }
      }
    }
    status
    createdByUsername
  }
}
    `;

/**
 * __useGetJobsByObjectIdQuery__
 *
 * To run a query within a React component, call `useGetJobsByObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsByObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsByObjectIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobsByObjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetJobsByObjectIdQuery, GetJobsByObjectIdQueryVariables> & ({ variables: GetJobsByObjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsByObjectIdQuery, GetJobsByObjectIdQueryVariables>(GetJobsByObjectIdDocument, options);
      }
export function useGetJobsByObjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsByObjectIdQuery, GetJobsByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsByObjectIdQuery, GetJobsByObjectIdQueryVariables>(GetJobsByObjectIdDocument, options);
        }
export function useGetJobsByObjectIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobsByObjectIdQuery, GetJobsByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobsByObjectIdQuery, GetJobsByObjectIdQueryVariables>(GetJobsByObjectIdDocument, options);
        }
export type GetJobsByObjectIdQueryHookResult = ReturnType<typeof useGetJobsByObjectIdQuery>;
export type GetJobsByObjectIdLazyQueryHookResult = ReturnType<typeof useGetJobsByObjectIdLazyQuery>;
export type GetJobsByObjectIdSuspenseQueryHookResult = ReturnType<typeof useGetJobsByObjectIdSuspenseQuery>;
export type GetJobsByObjectIdQueryResult = Apollo.QueryResult<GetJobsByObjectIdQuery, GetJobsByObjectIdQueryVariables>;
export const GetJobsByProjectIdDocument = gql`
    query GetJobsByProjectId($id: String!) {
  allJobsByProjectId(id: $id) {
    id
    description
    createdBy
    severity
    title
    startDate
    endDate
    status
    mdmObject {
      id
      title
      customFields {
        key
        value {
          type
          value
        }
      }
    }
    createdByUsername
  }
}
    `;

/**
 * __useGetJobsByProjectIdQuery__
 *
 * To run a query within a React component, call `useGetJobsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsByProjectIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobsByProjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetJobsByProjectIdQuery, GetJobsByProjectIdQueryVariables> & ({ variables: GetJobsByProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsByProjectIdQuery, GetJobsByProjectIdQueryVariables>(GetJobsByProjectIdDocument, options);
      }
export function useGetJobsByProjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsByProjectIdQuery, GetJobsByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsByProjectIdQuery, GetJobsByProjectIdQueryVariables>(GetJobsByProjectIdDocument, options);
        }
export function useGetJobsByProjectIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobsByProjectIdQuery, GetJobsByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobsByProjectIdQuery, GetJobsByProjectIdQueryVariables>(GetJobsByProjectIdDocument, options);
        }
export type GetJobsByProjectIdQueryHookResult = ReturnType<typeof useGetJobsByProjectIdQuery>;
export type GetJobsByProjectIdLazyQueryHookResult = ReturnType<typeof useGetJobsByProjectIdLazyQuery>;
export type GetJobsByProjectIdSuspenseQueryHookResult = ReturnType<typeof useGetJobsByProjectIdSuspenseQuery>;
export type GetJobsByProjectIdQueryResult = Apollo.QueryResult<GetJobsByProjectIdQuery, GetJobsByProjectIdQueryVariables>;
export const GetJobByIdDocument = gql`
    query GetJobById($id: BigInteger!) {
  jobById(id: $id) {
    id
    description
    createdBy
    severity
    title
    startDate
    endDate
    status
  }
}
    `;

/**
 * __useGetJobByIdQuery__
 *
 * To run a query within a React component, call `useGetJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobByIdQuery(baseOptions: Apollo.QueryHookOptions<GetJobByIdQuery, GetJobByIdQueryVariables> & ({ variables: GetJobByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobByIdQuery, GetJobByIdQueryVariables>(GetJobByIdDocument, options);
      }
export function useGetJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobByIdQuery, GetJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobByIdQuery, GetJobByIdQueryVariables>(GetJobByIdDocument, options);
        }
export function useGetJobByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJobByIdQuery, GetJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobByIdQuery, GetJobByIdQueryVariables>(GetJobByIdDocument, options);
        }
export type GetJobByIdQueryHookResult = ReturnType<typeof useGetJobByIdQuery>;
export type GetJobByIdLazyQueryHookResult = ReturnType<typeof useGetJobByIdLazyQuery>;
export type GetJobByIdSuspenseQueryHookResult = ReturnType<typeof useGetJobByIdSuspenseQuery>;
export type GetJobByIdQueryResult = Apollo.QueryResult<GetJobByIdQuery, GetJobByIdQueryVariables>;
export const CreateJobDocument = gql`
    mutation CreateJob($objectId: String!, $input: MdmObjectJobDTOInput!) {
  createJob(objectId: $objectId, mdmObjectJob: $input) {
    id
    description
    createdBy
    severity
    title
    startDate
    endDate
    status
  }
}
    `;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const UpdateJobDocument = gql`
    mutation UpdateJob($input: MdmObjectJobDTOInput!) {
  updateJob(mdmObjectJob: $input) {
    id
    description
    createdBy
    severity
    title
    startDate
    endDate
    status
  }
}
    `;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const DeleteJobDocument = gql`
    mutation DeleteJob($jobId: BigInteger!) {
  deleteJob(id: $jobId) {
    id
  }
}
    `;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, options);
      }
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const GetAllNotesDocument = gql`
    query GetAllNotes($id: String!) {
  allNotesByObjectId(id: $id) {
    note
    id
    createdAt
    modifiedAt
    createdByUsername
    modifiedByUsername
  }
}
    `;

/**
 * __useGetAllNotesQuery__
 *
 * To run a query within a React component, call `useGetAllNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllNotesQuery(baseOptions: Apollo.QueryHookOptions<GetAllNotesQuery, GetAllNotesQueryVariables> & ({ variables: GetAllNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNotesQuery, GetAllNotesQueryVariables>(GetAllNotesDocument, options);
      }
export function useGetAllNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNotesQuery, GetAllNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNotesQuery, GetAllNotesQueryVariables>(GetAllNotesDocument, options);
        }
export function useGetAllNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllNotesQuery, GetAllNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllNotesQuery, GetAllNotesQueryVariables>(GetAllNotesDocument, options);
        }
export type GetAllNotesQueryHookResult = ReturnType<typeof useGetAllNotesQuery>;
export type GetAllNotesLazyQueryHookResult = ReturnType<typeof useGetAllNotesLazyQuery>;
export type GetAllNotesSuspenseQueryHookResult = ReturnType<typeof useGetAllNotesSuspenseQuery>;
export type GetAllNotesQueryResult = Apollo.QueryResult<GetAllNotesQuery, GetAllNotesQueryVariables>;
export const CreateNoteDocument = gql`
    mutation createNote($objectId: String!, $note: String!) {
  createNote(mdmObjectId: $objectId, note: $note) {
    modifiedAt
    createdAt
    id
    note
    createdByUsername
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation updateNote($note: MdmObjectNoteDTOInput!) {
  updateNote(note: $note) {
    modifiedAt
    createdAt
    id
    note
    createdByUsername
    modifiedByUsername
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation deleteNote($id: BigInteger!) {
  deleteNote(id: $id) {
    id
  }
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const GetObjectsPagedDocument = gql`
    query GetObjectsPaged($input: ByProjectIdReqInput!) {
  mdmObjectsByProjectIdPaged(req: $input) {
    items {
      address {
        fullAddress
      }
      id
      location {
        latitude
        longitude
      }
      customFields {
        key
        value {
          type
          value
        }
      }
      tags
      title
      identifier
    }
    pageInfo {
      skip
      take
      total
    }
  }
}
    `;

/**
 * __useGetObjectsPagedQuery__
 *
 * To run a query within a React component, call `useGetObjectsPagedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectsPagedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectsPagedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetObjectsPagedQuery(baseOptions: Apollo.QueryHookOptions<GetObjectsPagedQuery, GetObjectsPagedQueryVariables> & ({ variables: GetObjectsPagedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjectsPagedQuery, GetObjectsPagedQueryVariables>(GetObjectsPagedDocument, options);
      }
export function useGetObjectsPagedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjectsPagedQuery, GetObjectsPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjectsPagedQuery, GetObjectsPagedQueryVariables>(GetObjectsPagedDocument, options);
        }
export function useGetObjectsPagedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObjectsPagedQuery, GetObjectsPagedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObjectsPagedQuery, GetObjectsPagedQueryVariables>(GetObjectsPagedDocument, options);
        }
export type GetObjectsPagedQueryHookResult = ReturnType<typeof useGetObjectsPagedQuery>;
export type GetObjectsPagedLazyQueryHookResult = ReturnType<typeof useGetObjectsPagedLazyQuery>;
export type GetObjectsPagedSuspenseQueryHookResult = ReturnType<typeof useGetObjectsPagedSuspenseQuery>;
export type GetObjectsPagedQueryResult = Apollo.QueryResult<GetObjectsPagedQuery, GetObjectsPagedQueryVariables>;
export const GetObjectsByProjectDocument = gql`
    query GetObjectsByProject($id: String!) {
  mdmObjectsByProjectId(projectId: $id) {
    id
    identifier
  }
}
    `;

/**
 * __useGetObjectsByProjectQuery__
 *
 * To run a query within a React component, call `useGetObjectsByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectsByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectsByProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetObjectsByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetObjectsByProjectQuery, GetObjectsByProjectQueryVariables> & ({ variables: GetObjectsByProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjectsByProjectQuery, GetObjectsByProjectQueryVariables>(GetObjectsByProjectDocument, options);
      }
export function useGetObjectsByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjectsByProjectQuery, GetObjectsByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjectsByProjectQuery, GetObjectsByProjectQueryVariables>(GetObjectsByProjectDocument, options);
        }
export function useGetObjectsByProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObjectsByProjectQuery, GetObjectsByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObjectsByProjectQuery, GetObjectsByProjectQueryVariables>(GetObjectsByProjectDocument, options);
        }
export type GetObjectsByProjectQueryHookResult = ReturnType<typeof useGetObjectsByProjectQuery>;
export type GetObjectsByProjectLazyQueryHookResult = ReturnType<typeof useGetObjectsByProjectLazyQuery>;
export type GetObjectsByProjectSuspenseQueryHookResult = ReturnType<typeof useGetObjectsByProjectSuspenseQuery>;
export type GetObjectsByProjectQueryResult = Apollo.QueryResult<GetObjectsByProjectQuery, GetObjectsByProjectQueryVariables>;
export const GetObjectDocument = gql`
    query GetObject($id: String!) {
  mdmObjectById(id: $id) {
    address {
      city
      country
      houseNumber
      postCode
      street
      fullAddress
    }
    customFields {
      key
      value {
        type
        value
      }
    }
    boundDatasets {
      all {
        dataset {
          identifier
          title
        }
      }
      indirect {
        dataset {
          identifier
          title
        }
      }
      direct {
        dataset {
          identifier
          title
        }
      }
      mapped {
        dataset {
          identifier
          title
        }
      }
    }
    description
    deviceRelations {
      mdmDevice {
        id
        identifier
        tags
        modifiedAt
        createdAt
        status {
          status
          lastMeasurementDate
        }
        customFields {
          key
          value {
            type
            value
          }
        }
      }
      roleInObject
    }
    id
    location {
      latitude
      longitude
    }
    tags
    title
    identifier
    info {
      jobsCount
      notesCount
    }
  }
}
    `;

/**
 * __useGetObjectQuery__
 *
 * To run a query within a React component, call `useGetObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetObjectQuery(baseOptions: Apollo.QueryHookOptions<GetObjectQuery, GetObjectQueryVariables> & ({ variables: GetObjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjectQuery, GetObjectQueryVariables>(GetObjectDocument, options);
      }
export function useGetObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjectQuery, GetObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjectQuery, GetObjectQueryVariables>(GetObjectDocument, options);
        }
export function useGetObjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObjectQuery, GetObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObjectQuery, GetObjectQueryVariables>(GetObjectDocument, options);
        }
export type GetObjectQueryHookResult = ReturnType<typeof useGetObjectQuery>;
export type GetObjectLazyQueryHookResult = ReturnType<typeof useGetObjectLazyQuery>;
export type GetObjectSuspenseQueryHookResult = ReturnType<typeof useGetObjectSuspenseQuery>;
export type GetObjectQueryResult = Apollo.QueryResult<GetObjectQuery, GetObjectQueryVariables>;
export const CreateObjectDocument = gql`
    mutation CreateObject($object: MdmObjectDTOInput!) {
  createMdmObject(input: $object) {
    id
    title
    identifier
    description
    tags
    address {
      city
      country
      houseNumber
      postCode
      street
    }
    location {
      latitude
      longitude
    }
  }
}
    `;
export type CreateObjectMutationFn = Apollo.MutationFunction<CreateObjectMutation, CreateObjectMutationVariables>;

/**
 * __useCreateObjectMutation__
 *
 * To run a mutation, you first call `useCreateObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObjectMutation, { data, loading, error }] = useCreateObjectMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateObjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateObjectMutation, CreateObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateObjectMutation, CreateObjectMutationVariables>(CreateObjectDocument, options);
      }
export type CreateObjectMutationHookResult = ReturnType<typeof useCreateObjectMutation>;
export type CreateObjectMutationResult = Apollo.MutationResult<CreateObjectMutation>;
export type CreateObjectMutationOptions = Apollo.BaseMutationOptions<CreateObjectMutation, CreateObjectMutationVariables>;
export const UpdateObjectDocument = gql`
    mutation UpdateObject($object: MdmObjectDTOInput!) {
  updateMdmObject(input: $object) {
    id
    title
    identifier
    description
    tags
    address {
      city
      country
      houseNumber
      postCode
      street
    }
    location {
      latitude
      longitude
    }
  }
}
    `;
export type UpdateObjectMutationFn = Apollo.MutationFunction<UpdateObjectMutation, UpdateObjectMutationVariables>;

/**
 * __useUpdateObjectMutation__
 *
 * To run a mutation, you first call `useUpdateObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjectMutation, { data, loading, error }] = useUpdateObjectMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateObjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateObjectMutation, UpdateObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateObjectMutation, UpdateObjectMutationVariables>(UpdateObjectDocument, options);
      }
export type UpdateObjectMutationHookResult = ReturnType<typeof useUpdateObjectMutation>;
export type UpdateObjectMutationResult = Apollo.MutationResult<UpdateObjectMutation>;
export type UpdateObjectMutationOptions = Apollo.BaseMutationOptions<UpdateObjectMutation, UpdateObjectMutationVariables>;
export const DeleteObjectDocument = gql`
    mutation DeleteObject($id: String!) {
  deleteMdmObject(id: $id) {
    id
    identifier
    title
  }
}
    `;
export type DeleteObjectMutationFn = Apollo.MutationFunction<DeleteObjectMutation, DeleteObjectMutationVariables>;

/**
 * __useDeleteObjectMutation__
 *
 * To run a mutation, you first call `useDeleteObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteObjectMutation, { data, loading, error }] = useDeleteObjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteObjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteObjectMutation, DeleteObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteObjectMutation, DeleteObjectMutationVariables>(DeleteObjectDocument, options);
      }
export type DeleteObjectMutationHookResult = ReturnType<typeof useDeleteObjectMutation>;
export type DeleteObjectMutationResult = Apollo.MutationResult<DeleteObjectMutation>;
export type DeleteObjectMutationOptions = Apollo.BaseMutationOptions<DeleteObjectMutation, DeleteObjectMutationVariables>;
export const GetProjectsByCompanyDocument = gql`
    query GetProjectsByCompany($refName: String!) {
  mdmProjectsByCompany(companyReference: $refName) {
    id
    title
  }
}
    `;

/**
 * __useGetProjectsByCompanyQuery__
 *
 * To run a query within a React component, call `useGetProjectsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsByCompanyQuery({
 *   variables: {
 *      refName: // value for 'refName'
 *   },
 * });
 */
export function useGetProjectsByCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetProjectsByCompanyQuery, GetProjectsByCompanyQueryVariables> & ({ variables: GetProjectsByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsByCompanyQuery, GetProjectsByCompanyQueryVariables>(GetProjectsByCompanyDocument, options);
      }
export function useGetProjectsByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsByCompanyQuery, GetProjectsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsByCompanyQuery, GetProjectsByCompanyQueryVariables>(GetProjectsByCompanyDocument, options);
        }
export function useGetProjectsByCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectsByCompanyQuery, GetProjectsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsByCompanyQuery, GetProjectsByCompanyQueryVariables>(GetProjectsByCompanyDocument, options);
        }
export type GetProjectsByCompanyQueryHookResult = ReturnType<typeof useGetProjectsByCompanyQuery>;
export type GetProjectsByCompanyLazyQueryHookResult = ReturnType<typeof useGetProjectsByCompanyLazyQuery>;
export type GetProjectsByCompanySuspenseQueryHookResult = ReturnType<typeof useGetProjectsByCompanySuspenseQuery>;
export type GetProjectsByCompanyQueryResult = Apollo.QueryResult<GetProjectsByCompanyQuery, GetProjectsByCompanyQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($id: String!) {
  mdmProjectById(id: $id) {
    companyReference
    id
    title
    datasetMode
    filterInfo {
      allFields {
        containerType
        fieldType
        key
        label
        inputType
        leaf
        enum {
          key
          label
        }
      }
      allOperators {
        key
        label
      }
    }
    deviceConfigs {
      id
      title
      vitalityThreshold
      measurementMappings {
        key
        value
      }
    }
    configuration {
      analyticsConfiguration {
        dataTypes {
          name
        }
        resultTypes {
          type
        }
      }
      objectConfiguration {
        customFields {
          id
          parent
          title
          type
          enums
          reading
        }
      }
      deviceConfiguration {
        customFields {
          id
          parent
          title
          type
          enums
          reading
        }
        measurementTypes {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables> & ({ variables: GetProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($project: MdmProjectInputInput!) {
  createMdmProject(input: $project) {
    id
    title
    companyReference
    datasetMode
    configuration {
      analyticsConfiguration {
        dataTypes {
          name
        }
        resultTypes {
          type
        }
      }
      objectConfiguration {
        customFields {
          id
          parent
          title
          type
        }
      }
      deviceConfiguration {
        customFields {
          id
          parent
          title
          type
        }
        measurementTypes {
          id
          title
        }
      }
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($project: MdmProjectDTOInput!) {
  updateMdmProject(input: $project) {
    companyReference
    id
    title
    datasetMode
    deviceConfigs {
      id
      title
      vitalityThreshold
      measurementMappings {
        key
        value
      }
    }
    configuration {
      analyticsConfiguration {
        dataTypes {
          name
        }
        resultTypes {
          type
        }
      }
      objectConfiguration {
        customFields {
          id
          parent
          title
          type
          enums
        }
      }
      deviceConfiguration {
        customFields {
          id
          parent
          title
          type
          enums
        }
        measurementTypes {
          id
          title
        }
      }
    }
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: String!) {
  deleteMdmProject(id: $id) {
    id
    title
  }
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const CreateUpdateDeviceConfigurationDocument = gql`
    mutation CreateUpdateDeviceConfiguration($input: MdmDeviceConfigDTOInput!) {
  createUpdateDeviceConfig(input: $input) {
    id
    title
    measurementMappings {
      key
      value
    }
    vitalityThreshold
  }
}
    `;
export type CreateUpdateDeviceConfigurationMutationFn = Apollo.MutationFunction<CreateUpdateDeviceConfigurationMutation, CreateUpdateDeviceConfigurationMutationVariables>;

/**
 * __useCreateUpdateDeviceConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateUpdateDeviceConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateDeviceConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateDeviceConfigurationMutation, { data, loading, error }] = useCreateUpdateDeviceConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateDeviceConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateDeviceConfigurationMutation, CreateUpdateDeviceConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateDeviceConfigurationMutation, CreateUpdateDeviceConfigurationMutationVariables>(CreateUpdateDeviceConfigurationDocument, options);
      }
export type CreateUpdateDeviceConfigurationMutationHookResult = ReturnType<typeof useCreateUpdateDeviceConfigurationMutation>;
export type CreateUpdateDeviceConfigurationMutationResult = Apollo.MutationResult<CreateUpdateDeviceConfigurationMutation>;
export type CreateUpdateDeviceConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateUpdateDeviceConfigurationMutation, CreateUpdateDeviceConfigurationMutationVariables>;
export const DeleteDeviceConfigurationDocument = gql`
    mutation DeleteDeviceConfiguration($id: String!) {
  deleteDeviceConfig(configId: $id) {
    id
  }
}
    `;
export type DeleteDeviceConfigurationMutationFn = Apollo.MutationFunction<DeleteDeviceConfigurationMutation, DeleteDeviceConfigurationMutationVariables>;

/**
 * __useDeleteDeviceConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteDeviceConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeviceConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeviceConfigurationMutation, { data, loading, error }] = useDeleteDeviceConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeviceConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeviceConfigurationMutation, DeleteDeviceConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeviceConfigurationMutation, DeleteDeviceConfigurationMutationVariables>(DeleteDeviceConfigurationDocument, options);
      }
export type DeleteDeviceConfigurationMutationHookResult = ReturnType<typeof useDeleteDeviceConfigurationMutation>;
export type DeleteDeviceConfigurationMutationResult = Apollo.MutationResult<DeleteDeviceConfigurationMutation>;
export type DeleteDeviceConfigurationMutationOptions = Apollo.BaseMutationOptions<DeleteDeviceConfigurationMutation, DeleteDeviceConfigurationMutationVariables>;
export const GetCoordinatesDocument = gql`
    query GetCoordinates($address: AddressInput!) {
  coordinates(address: $address) {
    latitude
    longitude
  }
}
    `;

/**
 * __useGetCoordinatesQuery__
 *
 * To run a query within a React component, call `useGetCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoordinatesQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<GetCoordinatesQuery, GetCoordinatesQueryVariables> & ({ variables: GetCoordinatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoordinatesQuery, GetCoordinatesQueryVariables>(GetCoordinatesDocument, options);
      }
export function useGetCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoordinatesQuery, GetCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoordinatesQuery, GetCoordinatesQueryVariables>(GetCoordinatesDocument, options);
        }
export function useGetCoordinatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoordinatesQuery, GetCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoordinatesQuery, GetCoordinatesQueryVariables>(GetCoordinatesDocument, options);
        }
export type GetCoordinatesQueryHookResult = ReturnType<typeof useGetCoordinatesQuery>;
export type GetCoordinatesLazyQueryHookResult = ReturnType<typeof useGetCoordinatesLazyQuery>;
export type GetCoordinatesSuspenseQueryHookResult = ReturnType<typeof useGetCoordinatesSuspenseQuery>;
export type GetCoordinatesQueryResult = Apollo.QueryResult<GetCoordinatesQuery, GetCoordinatesQueryVariables>;
export const GetUserSettingsDocument = gql`
    query GetUserSettings($id: String!) {
  userSettings(id: $id) {
    id {
      projectId
      userId
    }
    tableFilters {
      id
      title
      tableName
      andFilters {
        cond
        property
        value
      }
    }
    tablesDetails {
      rows
      table
      columnOrders {
        name
        order
      }
    }
  }
}
    `;

/**
 * __useGetUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables> & ({ variables: GetUserSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
      }
export function useGetUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
        }
export function useGetUserSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
        }
export type GetUserSettingsQueryHookResult = ReturnType<typeof useGetUserSettingsQuery>;
export type GetUserSettingsLazyQueryHookResult = ReturnType<typeof useGetUserSettingsLazyQuery>;
export type GetUserSettingsSuspenseQueryHookResult = ReturnType<typeof useGetUserSettingsSuspenseQuery>;
export type GetUserSettingsQueryResult = Apollo.QueryResult<GetUserSettingsQuery, GetUserSettingsQueryVariables>;
export const UpdateTableDetailsForUserDocument = gql`
    mutation updateTableDetailsForUser($projectId: String!, $tableDetails: TablesDetailsInput!) {
  updateTableDetailsForUser(projectId: $projectId, tableDetails: $tableDetails) {
    id {
      projectId
      userId
    }
    tablesDetails {
      rows
      table
      columnOrders {
        name
        order
      }
    }
  }
}
    `;
export type UpdateTableDetailsForUserMutationFn = Apollo.MutationFunction<UpdateTableDetailsForUserMutation, UpdateTableDetailsForUserMutationVariables>;

/**
 * __useUpdateTableDetailsForUserMutation__
 *
 * To run a mutation, you first call `useUpdateTableDetailsForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableDetailsForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableDetailsForUserMutation, { data, loading, error }] = useUpdateTableDetailsForUserMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      tableDetails: // value for 'tableDetails'
 *   },
 * });
 */
export function useUpdateTableDetailsForUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTableDetailsForUserMutation, UpdateTableDetailsForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTableDetailsForUserMutation, UpdateTableDetailsForUserMutationVariables>(UpdateTableDetailsForUserDocument, options);
      }
export type UpdateTableDetailsForUserMutationHookResult = ReturnType<typeof useUpdateTableDetailsForUserMutation>;
export type UpdateTableDetailsForUserMutationResult = Apollo.MutationResult<UpdateTableDetailsForUserMutation>;
export type UpdateTableDetailsForUserMutationOptions = Apollo.BaseMutationOptions<UpdateTableDetailsForUserMutation, UpdateTableDetailsForUserMutationVariables>;
export const UpdateTableFiltersDocument = gql`
    mutation updateTableFilters($projectId: String!, $tableFilter: TableFilterInput!) {
  updateTableFilters(projectId: $projectId, tableFilter: $tableFilter) {
    id {
      projectId
      userId
    }
    tableFilters {
      id
      title
      andFilters {
        cond
        property
        value
      }
    }
  }
}
    `;
export type UpdateTableFiltersMutationFn = Apollo.MutationFunction<UpdateTableFiltersMutation, UpdateTableFiltersMutationVariables>;

/**
 * __useUpdateTableFiltersMutation__
 *
 * To run a mutation, you first call `useUpdateTableFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableFiltersMutation, { data, loading, error }] = useUpdateTableFiltersMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      tableFilter: // value for 'tableFilter'
 *   },
 * });
 */
export function useUpdateTableFiltersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTableFiltersMutation, UpdateTableFiltersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTableFiltersMutation, UpdateTableFiltersMutationVariables>(UpdateTableFiltersDocument, options);
      }
export type UpdateTableFiltersMutationHookResult = ReturnType<typeof useUpdateTableFiltersMutation>;
export type UpdateTableFiltersMutationResult = Apollo.MutationResult<UpdateTableFiltersMutation>;
export type UpdateTableFiltersMutationOptions = Apollo.BaseMutationOptions<UpdateTableFiltersMutation, UpdateTableFiltersMutationVariables>;
export const DeleteTableFilterDocument = gql`
    mutation deleteTableFilter($projectId: String!, $filterId: String!) {
  deleteTableFilter(projectId: $projectId, filterId: $filterId) {
    id {
      projectId
      userId
    }
  }
}
    `;
export type DeleteTableFilterMutationFn = Apollo.MutationFunction<DeleteTableFilterMutation, DeleteTableFilterMutationVariables>;

/**
 * __useDeleteTableFilterMutation__
 *
 * To run a mutation, you first call `useDeleteTableFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableFilterMutation, { data, loading, error }] = useDeleteTableFilterMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      filterId: // value for 'filterId'
 *   },
 * });
 */
export function useDeleteTableFilterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTableFilterMutation, DeleteTableFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTableFilterMutation, DeleteTableFilterMutationVariables>(DeleteTableFilterDocument, options);
      }
export type DeleteTableFilterMutationHookResult = ReturnType<typeof useDeleteTableFilterMutation>;
export type DeleteTableFilterMutationResult = Apollo.MutationResult<DeleteTableFilterMutation>;
export type DeleteTableFilterMutationOptions = Apollo.BaseMutationOptions<DeleteTableFilterMutation, DeleteTableFilterMutationVariables>;